(() => {
  var __create = Object.create;
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __require = /* @__PURE__ */ ((x) => typeof require !== "undefined" ? require : typeof Proxy !== "undefined" ? new Proxy(x, {
    get: (a, b) => (typeof require !== "undefined" ? require : a)[b]
  }) : x)(function(x) {
    if (typeof require !== "undefined") return require.apply(this, arguments);
    throw Error('Dynamic require of "' + x + '" is not supported');
  });
  var __commonJS = (cb, mod) => function __require2() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
    mod
  ));

  // node_modules/localforage/dist/localforage.js
  var require_localforage = __commonJS({
    "node_modules/localforage/dist/localforage.js"(exports, module) {
      /*!
          localForage -- Offline Storage, Improved
          Version 1.10.0
          https://localforage.github.io/localForage
          (c) 2013-2017 Mozilla, Apache License 2.0
      */
      (function(f) {
        if (typeof exports === "object" && typeof module !== "undefined") {
          module.exports = f();
        } else if (typeof define === "function" && define.amd) {
          define([], f);
        } else {
          var g;
          if (typeof window !== "undefined") {
            g = window;
          } else if (typeof global !== "undefined") {
            g = global;
          } else if (typeof self !== "undefined") {
            g = self;
          } else {
            g = this;
          }
          g.localforage = f();
        }
      })(function() {
        var define2, module2, exports2;
        return function e(t, n, r) {
          function s(o2, u) {
            if (!n[o2]) {
              if (!t[o2]) {
                var a = typeof __require == "function" && __require;
                if (!u && a) return a(o2, true);
                if (i) return i(o2, true);
                var f = new Error("Cannot find module '" + o2 + "'");
                throw f.code = "MODULE_NOT_FOUND", f;
              }
              var l = n[o2] = { exports: {} };
              t[o2][0].call(l.exports, function(e2) {
                var n2 = t[o2][1][e2];
                return s(n2 ? n2 : e2);
              }, l, l.exports, e, t, n, r);
            }
            return n[o2].exports;
          }
          var i = typeof __require == "function" && __require;
          for (var o = 0; o < r.length; o++) s(r[o]);
          return s;
        }({ 1: [function(_dereq_, module3, exports3) {
          (function(global2) {
            "use strict";
            var Mutation = global2.MutationObserver || global2.WebKitMutationObserver;
            var scheduleDrain;
            {
              if (Mutation) {
                var called = 0;
                var observer = new Mutation(nextTick);
                var element = global2.document.createTextNode("");
                observer.observe(element, {
                  characterData: true
                });
                scheduleDrain = function() {
                  element.data = called = ++called % 2;
                };
              } else if (!global2.setImmediate && typeof global2.MessageChannel !== "undefined") {
                var channel = new global2.MessageChannel();
                channel.port1.onmessage = nextTick;
                scheduleDrain = function() {
                  channel.port2.postMessage(0);
                };
              } else if ("document" in global2 && "onreadystatechange" in global2.document.createElement("script")) {
                scheduleDrain = function() {
                  var scriptEl = global2.document.createElement("script");
                  scriptEl.onreadystatechange = function() {
                    nextTick();
                    scriptEl.onreadystatechange = null;
                    scriptEl.parentNode.removeChild(scriptEl);
                    scriptEl = null;
                  };
                  global2.document.documentElement.appendChild(scriptEl);
                };
              } else {
                scheduleDrain = function() {
                  setTimeout(nextTick, 0);
                };
              }
            }
            var draining;
            var queue = [];
            function nextTick() {
              draining = true;
              var i, oldQueue;
              var len = queue.length;
              while (len) {
                oldQueue = queue;
                queue = [];
                i = -1;
                while (++i < len) {
                  oldQueue[i]();
                }
                len = queue.length;
              }
              draining = false;
            }
            module3.exports = immediate;
            function immediate(task) {
              if (queue.push(task) === 1 && !draining) {
                scheduleDrain();
              }
            }
          }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
        }, {}], 2: [function(_dereq_, module3, exports3) {
          "use strict";
          var immediate = _dereq_(1);
          function INTERNAL() {
          }
          var handlers = {};
          var REJECTED = ["REJECTED"];
          var FULFILLED = ["FULFILLED"];
          var PENDING = ["PENDING"];
          module3.exports = Promise2;
          function Promise2(resolver) {
            if (typeof resolver !== "function") {
              throw new TypeError("resolver must be a function");
            }
            this.state = PENDING;
            this.queue = [];
            this.outcome = void 0;
            if (resolver !== INTERNAL) {
              safelyResolveThenable(this, resolver);
            }
          }
          Promise2.prototype["catch"] = function(onRejected) {
            return this.then(null, onRejected);
          };
          Promise2.prototype.then = function(onFulfilled, onRejected) {
            if (typeof onFulfilled !== "function" && this.state === FULFILLED || typeof onRejected !== "function" && this.state === REJECTED) {
              return this;
            }
            var promise = new this.constructor(INTERNAL);
            if (this.state !== PENDING) {
              var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
              unwrap(promise, resolver, this.outcome);
            } else {
              this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
            }
            return promise;
          };
          function QueueItem(promise, onFulfilled, onRejected) {
            this.promise = promise;
            if (typeof onFulfilled === "function") {
              this.onFulfilled = onFulfilled;
              this.callFulfilled = this.otherCallFulfilled;
            }
            if (typeof onRejected === "function") {
              this.onRejected = onRejected;
              this.callRejected = this.otherCallRejected;
            }
          }
          QueueItem.prototype.callFulfilled = function(value) {
            handlers.resolve(this.promise, value);
          };
          QueueItem.prototype.otherCallFulfilled = function(value) {
            unwrap(this.promise, this.onFulfilled, value);
          };
          QueueItem.prototype.callRejected = function(value) {
            handlers.reject(this.promise, value);
          };
          QueueItem.prototype.otherCallRejected = function(value) {
            unwrap(this.promise, this.onRejected, value);
          };
          function unwrap(promise, func, value) {
            immediate(function() {
              var returnValue;
              try {
                returnValue = func(value);
              } catch (e) {
                return handlers.reject(promise, e);
              }
              if (returnValue === promise) {
                handlers.reject(promise, new TypeError("Cannot resolve promise with itself"));
              } else {
                handlers.resolve(promise, returnValue);
              }
            });
          }
          handlers.resolve = function(self2, value) {
            var result = tryCatch(getThen, value);
            if (result.status === "error") {
              return handlers.reject(self2, result.value);
            }
            var thenable = result.value;
            if (thenable) {
              safelyResolveThenable(self2, thenable);
            } else {
              self2.state = FULFILLED;
              self2.outcome = value;
              var i = -1;
              var len = self2.queue.length;
              while (++i < len) {
                self2.queue[i].callFulfilled(value);
              }
            }
            return self2;
          };
          handlers.reject = function(self2, error) {
            self2.state = REJECTED;
            self2.outcome = error;
            var i = -1;
            var len = self2.queue.length;
            while (++i < len) {
              self2.queue[i].callRejected(error);
            }
            return self2;
          };
          function getThen(obj2) {
            var then = obj2 && obj2.then;
            if (obj2 && (typeof obj2 === "object" || typeof obj2 === "function") && typeof then === "function") {
              return function appyThen() {
                then.apply(obj2, arguments);
              };
            }
          }
          function safelyResolveThenable(self2, thenable) {
            var called = false;
            function onError(value) {
              if (called) {
                return;
              }
              called = true;
              handlers.reject(self2, value);
            }
            function onSuccess(value) {
              if (called) {
                return;
              }
              called = true;
              handlers.resolve(self2, value);
            }
            function tryToUnwrap() {
              thenable(onSuccess, onError);
            }
            var result = tryCatch(tryToUnwrap);
            if (result.status === "error") {
              onError(result.value);
            }
          }
          function tryCatch(func, value) {
            var out = {};
            try {
              out.value = func(value);
              out.status = "success";
            } catch (e) {
              out.status = "error";
              out.value = e;
            }
            return out;
          }
          Promise2.resolve = resolve;
          function resolve(value) {
            if (value instanceof this) {
              return value;
            }
            return handlers.resolve(new this(INTERNAL), value);
          }
          Promise2.reject = reject;
          function reject(reason) {
            var promise = new this(INTERNAL);
            return handlers.reject(promise, reason);
          }
          Promise2.all = all;
          function all(iterable) {
            var self2 = this;
            if (Object.prototype.toString.call(iterable) !== "[object Array]") {
              return this.reject(new TypeError("must be an array"));
            }
            var len = iterable.length;
            var called = false;
            if (!len) {
              return this.resolve([]);
            }
            var values = new Array(len);
            var resolved = 0;
            var i = -1;
            var promise = new this(INTERNAL);
            while (++i < len) {
              allResolver(iterable[i], i);
            }
            return promise;
            function allResolver(value, i2) {
              self2.resolve(value).then(resolveFromAll, function(error) {
                if (!called) {
                  called = true;
                  handlers.reject(promise, error);
                }
              });
              function resolveFromAll(outValue) {
                values[i2] = outValue;
                if (++resolved === len && !called) {
                  called = true;
                  handlers.resolve(promise, values);
                }
              }
            }
          }
          Promise2.race = race;
          function race(iterable) {
            var self2 = this;
            if (Object.prototype.toString.call(iterable) !== "[object Array]") {
              return this.reject(new TypeError("must be an array"));
            }
            var len = iterable.length;
            var called = false;
            if (!len) {
              return this.resolve([]);
            }
            var i = -1;
            var promise = new this(INTERNAL);
            while (++i < len) {
              resolver(iterable[i]);
            }
            return promise;
            function resolver(value) {
              self2.resolve(value).then(function(response) {
                if (!called) {
                  called = true;
                  handlers.resolve(promise, response);
                }
              }, function(error) {
                if (!called) {
                  called = true;
                  handlers.reject(promise, error);
                }
              });
            }
          }
        }, { "1": 1 }], 3: [function(_dereq_, module3, exports3) {
          (function(global2) {
            "use strict";
            if (typeof global2.Promise !== "function") {
              global2.Promise = _dereq_(2);
            }
          }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
        }, { "2": 2 }], 4: [function(_dereq_, module3, exports3) {
          "use strict";
          var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj2) {
            return typeof obj2;
          } : function(obj2) {
            return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
          };
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function getIDB() {
            try {
              if (typeof indexedDB !== "undefined") {
                return indexedDB;
              }
              if (typeof webkitIndexedDB !== "undefined") {
                return webkitIndexedDB;
              }
              if (typeof mozIndexedDB !== "undefined") {
                return mozIndexedDB;
              }
              if (typeof OIndexedDB !== "undefined") {
                return OIndexedDB;
              }
              if (typeof msIndexedDB !== "undefined") {
                return msIndexedDB;
              }
            } catch (e) {
              return;
            }
          }
          var idb = getIDB();
          function isIndexedDBValid() {
            try {
              if (!idb || !idb.open) {
                return false;
              }
              var isSafari = typeof openDatabase !== "undefined" && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);
              var hasFetch = typeof fetch === "function" && fetch.toString().indexOf("[native code") !== -1;
              return (!isSafari || hasFetch) && typeof indexedDB !== "undefined" && // some outdated implementations of IDB that appear on Samsung
              // and HTC Android devices <4.4 are missing IDBKeyRange
              // See: https://github.com/mozilla/localForage/issues/128
              // See: https://github.com/mozilla/localForage/issues/272
              typeof IDBKeyRange !== "undefined";
            } catch (e) {
              return false;
            }
          }
          function createBlob(parts, properties) {
            parts = parts || [];
            properties = properties || {};
            try {
              return new Blob(parts, properties);
            } catch (e) {
              if (e.name !== "TypeError") {
                throw e;
              }
              var Builder = typeof BlobBuilder !== "undefined" ? BlobBuilder : typeof MSBlobBuilder !== "undefined" ? MSBlobBuilder : typeof MozBlobBuilder !== "undefined" ? MozBlobBuilder : WebKitBlobBuilder;
              var builder = new Builder();
              for (var i = 0; i < parts.length; i += 1) {
                builder.append(parts[i]);
              }
              return builder.getBlob(properties.type);
            }
          }
          if (typeof Promise === "undefined") {
            _dereq_(3);
          }
          var Promise$1 = Promise;
          function executeCallback(promise, callback) {
            if (callback) {
              promise.then(function(result) {
                callback(null, result);
              }, function(error) {
                callback(error);
              });
            }
          }
          function executeTwoCallbacks(promise, callback, errorCallback) {
            if (typeof callback === "function") {
              promise.then(callback);
            }
            if (typeof errorCallback === "function") {
              promise["catch"](errorCallback);
            }
          }
          function normalizeKey(key2) {
            if (typeof key2 !== "string") {
              console.warn(key2 + " used as a key, but it is not a string.");
              key2 = String(key2);
            }
            return key2;
          }
          function getCallback() {
            if (arguments.length && typeof arguments[arguments.length - 1] === "function") {
              return arguments[arguments.length - 1];
            }
          }
          var DETECT_BLOB_SUPPORT_STORE = "local-forage-detect-blob-support";
          var supportsBlobs = void 0;
          var dbContexts = {};
          var toString = Object.prototype.toString;
          var READ_ONLY = "readonly";
          var READ_WRITE = "readwrite";
          function _binStringToArrayBuffer(bin) {
            var length2 = bin.length;
            var buf = new ArrayBuffer(length2);
            var arr = new Uint8Array(buf);
            for (var i = 0; i < length2; i++) {
              arr[i] = bin.charCodeAt(i);
            }
            return buf;
          }
          function _checkBlobSupportWithoutCaching(idb2) {
            return new Promise$1(function(resolve) {
              var txn = idb2.transaction(DETECT_BLOB_SUPPORT_STORE, READ_WRITE);
              var blob = createBlob([""]);
              txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, "key");
              txn.onabort = function(e) {
                e.preventDefault();
                e.stopPropagation();
                resolve(false);
              };
              txn.oncomplete = function() {
                var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
                var matchedEdge = navigator.userAgent.match(/Edge\//);
                resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
              };
            })["catch"](function() {
              return false;
            });
          }
          function _checkBlobSupport(idb2) {
            if (typeof supportsBlobs === "boolean") {
              return Promise$1.resolve(supportsBlobs);
            }
            return _checkBlobSupportWithoutCaching(idb2).then(function(value) {
              supportsBlobs = value;
              return supportsBlobs;
            });
          }
          function _deferReadiness(dbInfo) {
            var dbContext = dbContexts[dbInfo.name];
            var deferredOperation = {};
            deferredOperation.promise = new Promise$1(function(resolve, reject) {
              deferredOperation.resolve = resolve;
              deferredOperation.reject = reject;
            });
            dbContext.deferredOperations.push(deferredOperation);
            if (!dbContext.dbReady) {
              dbContext.dbReady = deferredOperation.promise;
            } else {
              dbContext.dbReady = dbContext.dbReady.then(function() {
                return deferredOperation.promise;
              });
            }
          }
          function _advanceReadiness(dbInfo) {
            var dbContext = dbContexts[dbInfo.name];
            var deferredOperation = dbContext.deferredOperations.pop();
            if (deferredOperation) {
              deferredOperation.resolve();
              return deferredOperation.promise;
            }
          }
          function _rejectReadiness(dbInfo, err) {
            var dbContext = dbContexts[dbInfo.name];
            var deferredOperation = dbContext.deferredOperations.pop();
            if (deferredOperation) {
              deferredOperation.reject(err);
              return deferredOperation.promise;
            }
          }
          function _getConnection(dbInfo, upgradeNeeded) {
            return new Promise$1(function(resolve, reject) {
              dbContexts[dbInfo.name] = dbContexts[dbInfo.name] || createDbContext();
              if (dbInfo.db) {
                if (upgradeNeeded) {
                  _deferReadiness(dbInfo);
                  dbInfo.db.close();
                } else {
                  return resolve(dbInfo.db);
                }
              }
              var dbArgs = [dbInfo.name];
              if (upgradeNeeded) {
                dbArgs.push(dbInfo.version);
              }
              var openreq = idb.open.apply(idb, dbArgs);
              if (upgradeNeeded) {
                openreq.onupgradeneeded = function(e) {
                  var db = openreq.result;
                  try {
                    db.createObjectStore(dbInfo.storeName);
                    if (e.oldVersion <= 1) {
                      db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
                    }
                  } catch (ex) {
                    if (ex.name === "ConstraintError") {
                      console.warn('The database "' + dbInfo.name + '" has been upgraded from version ' + e.oldVersion + " to version " + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
                    } else {
                      throw ex;
                    }
                  }
                };
              }
              openreq.onerror = function(e) {
                e.preventDefault();
                reject(openreq.error);
              };
              openreq.onsuccess = function() {
                var db = openreq.result;
                db.onversionchange = function(e) {
                  e.target.close();
                };
                resolve(db);
                _advanceReadiness(dbInfo);
              };
            });
          }
          function _getOriginalConnection(dbInfo) {
            return _getConnection(dbInfo, false);
          }
          function _getUpgradedConnection(dbInfo) {
            return _getConnection(dbInfo, true);
          }
          function _isUpgradeNeeded(dbInfo, defaultVersion) {
            if (!dbInfo.db) {
              return true;
            }
            var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
            var isDowngrade = dbInfo.version < dbInfo.db.version;
            var isUpgrade = dbInfo.version > dbInfo.db.version;
            if (isDowngrade) {
              if (dbInfo.version !== defaultVersion) {
                console.warn('The database "' + dbInfo.name + `" can't be downgraded from version ` + dbInfo.db.version + " to version " + dbInfo.version + ".");
              }
              dbInfo.version = dbInfo.db.version;
            }
            if (isUpgrade || isNewStore) {
              if (isNewStore) {
                var incVersion = dbInfo.db.version + 1;
                if (incVersion > dbInfo.version) {
                  dbInfo.version = incVersion;
                }
              }
              return true;
            }
            return false;
          }
          function _encodeBlob(blob) {
            return new Promise$1(function(resolve, reject) {
              var reader = new FileReader();
              reader.onerror = reject;
              reader.onloadend = function(e) {
                var base64 = btoa(e.target.result || "");
                resolve({
                  __local_forage_encoded_blob: true,
                  data: base64,
                  type: blob.type
                });
              };
              reader.readAsBinaryString(blob);
            });
          }
          function _decodeBlob(encodedBlob) {
            var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
            return createBlob([arrayBuff], { type: encodedBlob.type });
          }
          function _isEncodedBlob(value) {
            return value && value.__local_forage_encoded_blob;
          }
          function _fullyReady(callback) {
            var self2 = this;
            var promise = self2._initReady().then(function() {
              var dbContext = dbContexts[self2._dbInfo.name];
              if (dbContext && dbContext.dbReady) {
                return dbContext.dbReady;
              }
            });
            executeTwoCallbacks(promise, callback, callback);
            return promise;
          }
          function _tryReconnect(dbInfo) {
            _deferReadiness(dbInfo);
            var dbContext = dbContexts[dbInfo.name];
            var forages = dbContext.forages;
            for (var i = 0; i < forages.length; i++) {
              var forage = forages[i];
              if (forage._dbInfo.db) {
                forage._dbInfo.db.close();
                forage._dbInfo.db = null;
              }
            }
            dbInfo.db = null;
            return _getOriginalConnection(dbInfo).then(function(db) {
              dbInfo.db = db;
              if (_isUpgradeNeeded(dbInfo)) {
                return _getUpgradedConnection(dbInfo);
              }
              return db;
            }).then(function(db) {
              dbInfo.db = dbContext.db = db;
              for (var i2 = 0; i2 < forages.length; i2++) {
                forages[i2]._dbInfo.db = db;
              }
            })["catch"](function(err) {
              _rejectReadiness(dbInfo, err);
              throw err;
            });
          }
          function createTransaction(dbInfo, mode, callback, retries) {
            if (retries === void 0) {
              retries = 1;
            }
            try {
              var tx = dbInfo.db.transaction(dbInfo.storeName, mode);
              callback(null, tx);
            } catch (err) {
              if (retries > 0 && (!dbInfo.db || err.name === "InvalidStateError" || err.name === "NotFoundError")) {
                return Promise$1.resolve().then(function() {
                  if (!dbInfo.db || err.name === "NotFoundError" && !dbInfo.db.objectStoreNames.contains(dbInfo.storeName) && dbInfo.version <= dbInfo.db.version) {
                    if (dbInfo.db) {
                      dbInfo.version = dbInfo.db.version + 1;
                    }
                    return _getUpgradedConnection(dbInfo);
                  }
                }).then(function() {
                  return _tryReconnect(dbInfo).then(function() {
                    createTransaction(dbInfo, mode, callback, retries - 1);
                  });
                })["catch"](callback);
              }
              callback(err);
            }
          }
          function createDbContext() {
            return {
              // Running localForages sharing a database.
              forages: [],
              // Shared database.
              db: null,
              // Database readiness (promise).
              dbReady: null,
              // Deferred operations on the database.
              deferredOperations: []
            };
          }
          function _initStorage(options) {
            var self2 = this;
            var dbInfo = {
              db: null
            };
            if (options) {
              for (var i in options) {
                dbInfo[i] = options[i];
              }
            }
            var dbContext = dbContexts[dbInfo.name];
            if (!dbContext) {
              dbContext = createDbContext();
              dbContexts[dbInfo.name] = dbContext;
            }
            dbContext.forages.push(self2);
            if (!self2._initReady) {
              self2._initReady = self2.ready;
              self2.ready = _fullyReady;
            }
            var initPromises = [];
            function ignoreErrors() {
              return Promise$1.resolve();
            }
            for (var j = 0; j < dbContext.forages.length; j++) {
              var forage = dbContext.forages[j];
              if (forage !== self2) {
                initPromises.push(forage._initReady()["catch"](ignoreErrors));
              }
            }
            var forages = dbContext.forages.slice(0);
            return Promise$1.all(initPromises).then(function() {
              dbInfo.db = dbContext.db;
              return _getOriginalConnection(dbInfo);
            }).then(function(db) {
              dbInfo.db = db;
              if (_isUpgradeNeeded(dbInfo, self2._defaultConfig.version)) {
                return _getUpgradedConnection(dbInfo);
              }
              return db;
            }).then(function(db) {
              dbInfo.db = dbContext.db = db;
              self2._dbInfo = dbInfo;
              for (var k = 0; k < forages.length; k++) {
                var forage2 = forages[k];
                if (forage2 !== self2) {
                  forage2._dbInfo.db = dbInfo.db;
                  forage2._dbInfo.version = dbInfo.version;
                }
              }
            });
          }
          function getItem(key2, callback) {
            var self2 = this;
            key2 = normalizeKey(key2);
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                createTransaction(self2._dbInfo, READ_ONLY, function(err, transaction) {
                  if (err) {
                    return reject(err);
                  }
                  try {
                    var store = transaction.objectStore(self2._dbInfo.storeName);
                    var req = store.get(key2);
                    req.onsuccess = function() {
                      var value = req.result;
                      if (value === void 0) {
                        value = null;
                      }
                      if (_isEncodedBlob(value)) {
                        value = _decodeBlob(value);
                      }
                      resolve(value);
                    };
                    req.onerror = function() {
                      reject(req.error);
                    };
                  } catch (e) {
                    reject(e);
                  }
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function iterate(iterator, callback) {
            var self2 = this;
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                createTransaction(self2._dbInfo, READ_ONLY, function(err, transaction) {
                  if (err) {
                    return reject(err);
                  }
                  try {
                    var store = transaction.objectStore(self2._dbInfo.storeName);
                    var req = store.openCursor();
                    var iterationNumber = 1;
                    req.onsuccess = function() {
                      var cursor = req.result;
                      if (cursor) {
                        var value = cursor.value;
                        if (_isEncodedBlob(value)) {
                          value = _decodeBlob(value);
                        }
                        var result = iterator(value, cursor.key, iterationNumber++);
                        if (result !== void 0) {
                          resolve(result);
                        } else {
                          cursor["continue"]();
                        }
                      } else {
                        resolve();
                      }
                    };
                    req.onerror = function() {
                      reject(req.error);
                    };
                  } catch (e) {
                    reject(e);
                  }
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function setItem(key2, value, callback) {
            var self2 = this;
            key2 = normalizeKey(key2);
            var promise = new Promise$1(function(resolve, reject) {
              var dbInfo;
              self2.ready().then(function() {
                dbInfo = self2._dbInfo;
                if (toString.call(value) === "[object Blob]") {
                  return _checkBlobSupport(dbInfo.db).then(function(blobSupport) {
                    if (blobSupport) {
                      return value;
                    }
                    return _encodeBlob(value);
                  });
                }
                return value;
              }).then(function(value2) {
                createTransaction(self2._dbInfo, READ_WRITE, function(err, transaction) {
                  if (err) {
                    return reject(err);
                  }
                  try {
                    var store = transaction.objectStore(self2._dbInfo.storeName);
                    if (value2 === null) {
                      value2 = void 0;
                    }
                    var req = store.put(value2, key2);
                    transaction.oncomplete = function() {
                      if (value2 === void 0) {
                        value2 = null;
                      }
                      resolve(value2);
                    };
                    transaction.onabort = transaction.onerror = function() {
                      var err2 = req.error ? req.error : req.transaction.error;
                      reject(err2);
                    };
                  } catch (e) {
                    reject(e);
                  }
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function removeItem(key2, callback) {
            var self2 = this;
            key2 = normalizeKey(key2);
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                createTransaction(self2._dbInfo, READ_WRITE, function(err, transaction) {
                  if (err) {
                    return reject(err);
                  }
                  try {
                    var store = transaction.objectStore(self2._dbInfo.storeName);
                    var req = store["delete"](key2);
                    transaction.oncomplete = function() {
                      resolve();
                    };
                    transaction.onerror = function() {
                      reject(req.error);
                    };
                    transaction.onabort = function() {
                      var err2 = req.error ? req.error : req.transaction.error;
                      reject(err2);
                    };
                  } catch (e) {
                    reject(e);
                  }
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function clear(callback) {
            var self2 = this;
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                createTransaction(self2._dbInfo, READ_WRITE, function(err, transaction) {
                  if (err) {
                    return reject(err);
                  }
                  try {
                    var store = transaction.objectStore(self2._dbInfo.storeName);
                    var req = store.clear();
                    transaction.oncomplete = function() {
                      resolve();
                    };
                    transaction.onabort = transaction.onerror = function() {
                      var err2 = req.error ? req.error : req.transaction.error;
                      reject(err2);
                    };
                  } catch (e) {
                    reject(e);
                  }
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function length(callback) {
            var self2 = this;
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                createTransaction(self2._dbInfo, READ_ONLY, function(err, transaction) {
                  if (err) {
                    return reject(err);
                  }
                  try {
                    var store = transaction.objectStore(self2._dbInfo.storeName);
                    var req = store.count();
                    req.onsuccess = function() {
                      resolve(req.result);
                    };
                    req.onerror = function() {
                      reject(req.error);
                    };
                  } catch (e) {
                    reject(e);
                  }
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function key(n, callback) {
            var self2 = this;
            var promise = new Promise$1(function(resolve, reject) {
              if (n < 0) {
                resolve(null);
                return;
              }
              self2.ready().then(function() {
                createTransaction(self2._dbInfo, READ_ONLY, function(err, transaction) {
                  if (err) {
                    return reject(err);
                  }
                  try {
                    var store = transaction.objectStore(self2._dbInfo.storeName);
                    var advanced = false;
                    var req = store.openKeyCursor();
                    req.onsuccess = function() {
                      var cursor = req.result;
                      if (!cursor) {
                        resolve(null);
                        return;
                      }
                      if (n === 0) {
                        resolve(cursor.key);
                      } else {
                        if (!advanced) {
                          advanced = true;
                          cursor.advance(n);
                        } else {
                          resolve(cursor.key);
                        }
                      }
                    };
                    req.onerror = function() {
                      reject(req.error);
                    };
                  } catch (e) {
                    reject(e);
                  }
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function keys(callback) {
            var self2 = this;
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                createTransaction(self2._dbInfo, READ_ONLY, function(err, transaction) {
                  if (err) {
                    return reject(err);
                  }
                  try {
                    var store = transaction.objectStore(self2._dbInfo.storeName);
                    var req = store.openKeyCursor();
                    var keys2 = [];
                    req.onsuccess = function() {
                      var cursor = req.result;
                      if (!cursor) {
                        resolve(keys2);
                        return;
                      }
                      keys2.push(cursor.key);
                      cursor["continue"]();
                    };
                    req.onerror = function() {
                      reject(req.error);
                    };
                  } catch (e) {
                    reject(e);
                  }
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function dropInstance(options, callback) {
            callback = getCallback.apply(this, arguments);
            var currentConfig = this.config();
            options = typeof options !== "function" && options || {};
            if (!options.name) {
              options.name = options.name || currentConfig.name;
              options.storeName = options.storeName || currentConfig.storeName;
            }
            var self2 = this;
            var promise;
            if (!options.name) {
              promise = Promise$1.reject("Invalid arguments");
            } else {
              var isCurrentDb = options.name === currentConfig.name && self2._dbInfo.db;
              var dbPromise = isCurrentDb ? Promise$1.resolve(self2._dbInfo.db) : _getOriginalConnection(options).then(function(db) {
                var dbContext = dbContexts[options.name];
                var forages = dbContext.forages;
                dbContext.db = db;
                for (var i = 0; i < forages.length; i++) {
                  forages[i]._dbInfo.db = db;
                }
                return db;
              });
              if (!options.storeName) {
                promise = dbPromise.then(function(db) {
                  _deferReadiness(options);
                  var dbContext = dbContexts[options.name];
                  var forages = dbContext.forages;
                  db.close();
                  for (var i = 0; i < forages.length; i++) {
                    var forage = forages[i];
                    forage._dbInfo.db = null;
                  }
                  var dropDBPromise = new Promise$1(function(resolve, reject) {
                    var req = idb.deleteDatabase(options.name);
                    req.onerror = function() {
                      var db2 = req.result;
                      if (db2) {
                        db2.close();
                      }
                      reject(req.error);
                    };
                    req.onblocked = function() {
                      console.warn('dropInstance blocked for database "' + options.name + '" until all open connections are closed');
                    };
                    req.onsuccess = function() {
                      var db2 = req.result;
                      if (db2) {
                        db2.close();
                      }
                      resolve(db2);
                    };
                  });
                  return dropDBPromise.then(function(db2) {
                    dbContext.db = db2;
                    for (var i2 = 0; i2 < forages.length; i2++) {
                      var _forage = forages[i2];
                      _advanceReadiness(_forage._dbInfo);
                    }
                  })["catch"](function(err) {
                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function() {
                    });
                    throw err;
                  });
                });
              } else {
                promise = dbPromise.then(function(db) {
                  if (!db.objectStoreNames.contains(options.storeName)) {
                    return;
                  }
                  var newVersion = db.version + 1;
                  _deferReadiness(options);
                  var dbContext = dbContexts[options.name];
                  var forages = dbContext.forages;
                  db.close();
                  for (var i = 0; i < forages.length; i++) {
                    var forage = forages[i];
                    forage._dbInfo.db = null;
                    forage._dbInfo.version = newVersion;
                  }
                  var dropObjectPromise = new Promise$1(function(resolve, reject) {
                    var req = idb.open(options.name, newVersion);
                    req.onerror = function(err) {
                      var db2 = req.result;
                      db2.close();
                      reject(err);
                    };
                    req.onupgradeneeded = function() {
                      var db2 = req.result;
                      db2.deleteObjectStore(options.storeName);
                    };
                    req.onsuccess = function() {
                      var db2 = req.result;
                      db2.close();
                      resolve(db2);
                    };
                  });
                  return dropObjectPromise.then(function(db2) {
                    dbContext.db = db2;
                    for (var j = 0; j < forages.length; j++) {
                      var _forage2 = forages[j];
                      _forage2._dbInfo.db = db2;
                      _advanceReadiness(_forage2._dbInfo);
                    }
                  })["catch"](function(err) {
                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function() {
                    });
                    throw err;
                  });
                });
              }
            }
            executeCallback(promise, callback);
            return promise;
          }
          var asyncStorage = {
            _driver: "asyncStorage",
            _initStorage,
            _support: isIndexedDBValid(),
            iterate,
            getItem,
            setItem,
            removeItem,
            clear,
            length,
            key,
            keys,
            dropInstance
          };
          function isWebSQLValid() {
            return typeof openDatabase === "function";
          }
          var BASE_CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
          var BLOB_TYPE_PREFIX = "~~local_forage_type~";
          var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;
          var SERIALIZED_MARKER = "__lfsc__:";
          var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;
          var TYPE_ARRAYBUFFER = "arbf";
          var TYPE_BLOB = "blob";
          var TYPE_INT8ARRAY = "si08";
          var TYPE_UINT8ARRAY = "ui08";
          var TYPE_UINT8CLAMPEDARRAY = "uic8";
          var TYPE_INT16ARRAY = "si16";
          var TYPE_INT32ARRAY = "si32";
          var TYPE_UINT16ARRAY = "ur16";
          var TYPE_UINT32ARRAY = "ui32";
          var TYPE_FLOAT32ARRAY = "fl32";
          var TYPE_FLOAT64ARRAY = "fl64";
          var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;
          var toString$1 = Object.prototype.toString;
          function stringToBuffer(serializedString) {
            var bufferLength = serializedString.length * 0.75;
            var len = serializedString.length;
            var i;
            var p = 0;
            var encoded1, encoded2, encoded3, encoded4;
            if (serializedString[serializedString.length - 1] === "=") {
              bufferLength--;
              if (serializedString[serializedString.length - 2] === "=") {
                bufferLength--;
              }
            }
            var buffer = new ArrayBuffer(bufferLength);
            var bytes = new Uint8Array(buffer);
            for (i = 0; i < len; i += 4) {
              encoded1 = BASE_CHARS.indexOf(serializedString[i]);
              encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
              encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
              encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);
              bytes[p++] = encoded1 << 2 | encoded2 >> 4;
              bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
              bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
            }
            return buffer;
          }
          function bufferToString(buffer) {
            var bytes = new Uint8Array(buffer);
            var base64String = "";
            var i;
            for (i = 0; i < bytes.length; i += 3) {
              base64String += BASE_CHARS[bytes[i] >> 2];
              base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
              base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
              base64String += BASE_CHARS[bytes[i + 2] & 63];
            }
            if (bytes.length % 3 === 2) {
              base64String = base64String.substring(0, base64String.length - 1) + "=";
            } else if (bytes.length % 3 === 1) {
              base64String = base64String.substring(0, base64String.length - 2) + "==";
            }
            return base64String;
          }
          function serialize(value, callback) {
            var valueType = "";
            if (value) {
              valueType = toString$1.call(value);
            }
            if (value && (valueType === "[object ArrayBuffer]" || value.buffer && toString$1.call(value.buffer) === "[object ArrayBuffer]")) {
              var buffer;
              var marker = SERIALIZED_MARKER;
              if (value instanceof ArrayBuffer) {
                buffer = value;
                marker += TYPE_ARRAYBUFFER;
              } else {
                buffer = value.buffer;
                if (valueType === "[object Int8Array]") {
                  marker += TYPE_INT8ARRAY;
                } else if (valueType === "[object Uint8Array]") {
                  marker += TYPE_UINT8ARRAY;
                } else if (valueType === "[object Uint8ClampedArray]") {
                  marker += TYPE_UINT8CLAMPEDARRAY;
                } else if (valueType === "[object Int16Array]") {
                  marker += TYPE_INT16ARRAY;
                } else if (valueType === "[object Uint16Array]") {
                  marker += TYPE_UINT16ARRAY;
                } else if (valueType === "[object Int32Array]") {
                  marker += TYPE_INT32ARRAY;
                } else if (valueType === "[object Uint32Array]") {
                  marker += TYPE_UINT32ARRAY;
                } else if (valueType === "[object Float32Array]") {
                  marker += TYPE_FLOAT32ARRAY;
                } else if (valueType === "[object Float64Array]") {
                  marker += TYPE_FLOAT64ARRAY;
                } else {
                  callback(new Error("Failed to get type for BinaryArray"));
                }
              }
              callback(marker + bufferToString(buffer));
            } else if (valueType === "[object Blob]") {
              var fileReader = new FileReader();
              fileReader.onload = function() {
                var str = BLOB_TYPE_PREFIX + value.type + "~" + bufferToString(this.result);
                callback(SERIALIZED_MARKER + TYPE_BLOB + str);
              };
              fileReader.readAsArrayBuffer(value);
            } else {
              try {
                callback(JSON.stringify(value));
              } catch (e) {
                console.error("Couldn't convert value into a JSON string: ", value);
                callback(null, e);
              }
            }
          }
          function deserialize(value) {
            if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) {
              return JSON.parse(value);
            }
            var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
            var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);
            var blobType;
            if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
              var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
              blobType = matcher[1];
              serializedString = serializedString.substring(matcher[0].length);
            }
            var buffer = stringToBuffer(serializedString);
            switch (type) {
              case TYPE_ARRAYBUFFER:
                return buffer;
              case TYPE_BLOB:
                return createBlob([buffer], { type: blobType });
              case TYPE_INT8ARRAY:
                return new Int8Array(buffer);
              case TYPE_UINT8ARRAY:
                return new Uint8Array(buffer);
              case TYPE_UINT8CLAMPEDARRAY:
                return new Uint8ClampedArray(buffer);
              case TYPE_INT16ARRAY:
                return new Int16Array(buffer);
              case TYPE_UINT16ARRAY:
                return new Uint16Array(buffer);
              case TYPE_INT32ARRAY:
                return new Int32Array(buffer);
              case TYPE_UINT32ARRAY:
                return new Uint32Array(buffer);
              case TYPE_FLOAT32ARRAY:
                return new Float32Array(buffer);
              case TYPE_FLOAT64ARRAY:
                return new Float64Array(buffer);
              default:
                throw new Error("Unkown type: " + type);
            }
          }
          var localforageSerializer = {
            serialize,
            deserialize,
            stringToBuffer,
            bufferToString
          };
          function createDbTable(t, dbInfo, callback, errorCallback) {
            t.executeSql("CREATE TABLE IF NOT EXISTS " + dbInfo.storeName + " (id INTEGER PRIMARY KEY, key unique, value)", [], callback, errorCallback);
          }
          function _initStorage$1(options) {
            var self2 = this;
            var dbInfo = {
              db: null
            };
            if (options) {
              for (var i in options) {
                dbInfo[i] = typeof options[i] !== "string" ? options[i].toString() : options[i];
              }
            }
            var dbInfoPromise = new Promise$1(function(resolve, reject) {
              try {
                dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
              } catch (e) {
                return reject(e);
              }
              dbInfo.db.transaction(function(t) {
                createDbTable(t, dbInfo, function() {
                  self2._dbInfo = dbInfo;
                  resolve();
                }, function(t2, error) {
                  reject(error);
                });
              }, reject);
            });
            dbInfo.serializer = localforageSerializer;
            return dbInfoPromise;
          }
          function tryExecuteSql(t, dbInfo, sqlStatement, args, callback, errorCallback) {
            t.executeSql(sqlStatement, args, callback, function(t2, error) {
              if (error.code === error.SYNTAX_ERR) {
                t2.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name = ?", [dbInfo.storeName], function(t3, results) {
                  if (!results.rows.length) {
                    createDbTable(t3, dbInfo, function() {
                      t3.executeSql(sqlStatement, args, callback, errorCallback);
                    }, errorCallback);
                  } else {
                    errorCallback(t3, error);
                  }
                }, errorCallback);
              } else {
                errorCallback(t2, error);
              }
            }, errorCallback);
          }
          function getItem$1(key2, callback) {
            var self2 = this;
            key2 = normalizeKey(key2);
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                var dbInfo = self2._dbInfo;
                dbInfo.db.transaction(function(t) {
                  tryExecuteSql(t, dbInfo, "SELECT * FROM " + dbInfo.storeName + " WHERE key = ? LIMIT 1", [key2], function(t2, results) {
                    var result = results.rows.length ? results.rows.item(0).value : null;
                    if (result) {
                      result = dbInfo.serializer.deserialize(result);
                    }
                    resolve(result);
                  }, function(t2, error) {
                    reject(error);
                  });
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function iterate$1(iterator, callback) {
            var self2 = this;
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                var dbInfo = self2._dbInfo;
                dbInfo.db.transaction(function(t) {
                  tryExecuteSql(t, dbInfo, "SELECT * FROM " + dbInfo.storeName, [], function(t2, results) {
                    var rows = results.rows;
                    var length2 = rows.length;
                    for (var i = 0; i < length2; i++) {
                      var item = rows.item(i);
                      var result = item.value;
                      if (result) {
                        result = dbInfo.serializer.deserialize(result);
                      }
                      result = iterator(result, item.key, i + 1);
                      if (result !== void 0) {
                        resolve(result);
                        return;
                      }
                    }
                    resolve();
                  }, function(t2, error) {
                    reject(error);
                  });
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function _setItem(key2, value, callback, retriesLeft) {
            var self2 = this;
            key2 = normalizeKey(key2);
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                if (value === void 0) {
                  value = null;
                }
                var originalValue = value;
                var dbInfo = self2._dbInfo;
                dbInfo.serializer.serialize(value, function(value2, error) {
                  if (error) {
                    reject(error);
                  } else {
                    dbInfo.db.transaction(function(t) {
                      tryExecuteSql(t, dbInfo, "INSERT OR REPLACE INTO " + dbInfo.storeName + " (key, value) VALUES (?, ?)", [key2, value2], function() {
                        resolve(originalValue);
                      }, function(t2, error2) {
                        reject(error2);
                      });
                    }, function(sqlError) {
                      if (sqlError.code === sqlError.QUOTA_ERR) {
                        if (retriesLeft > 0) {
                          resolve(_setItem.apply(self2, [key2, originalValue, callback, retriesLeft - 1]));
                          return;
                        }
                        reject(sqlError);
                      }
                    });
                  }
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function setItem$1(key2, value, callback) {
            return _setItem.apply(this, [key2, value, callback, 1]);
          }
          function removeItem$1(key2, callback) {
            var self2 = this;
            key2 = normalizeKey(key2);
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                var dbInfo = self2._dbInfo;
                dbInfo.db.transaction(function(t) {
                  tryExecuteSql(t, dbInfo, "DELETE FROM " + dbInfo.storeName + " WHERE key = ?", [key2], function() {
                    resolve();
                  }, function(t2, error) {
                    reject(error);
                  });
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function clear$1(callback) {
            var self2 = this;
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                var dbInfo = self2._dbInfo;
                dbInfo.db.transaction(function(t) {
                  tryExecuteSql(t, dbInfo, "DELETE FROM " + dbInfo.storeName, [], function() {
                    resolve();
                  }, function(t2, error) {
                    reject(error);
                  });
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function length$1(callback) {
            var self2 = this;
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                var dbInfo = self2._dbInfo;
                dbInfo.db.transaction(function(t) {
                  tryExecuteSql(t, dbInfo, "SELECT COUNT(key) as c FROM " + dbInfo.storeName, [], function(t2, results) {
                    var result = results.rows.item(0).c;
                    resolve(result);
                  }, function(t2, error) {
                    reject(error);
                  });
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function key$1(n, callback) {
            var self2 = this;
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                var dbInfo = self2._dbInfo;
                dbInfo.db.transaction(function(t) {
                  tryExecuteSql(t, dbInfo, "SELECT key FROM " + dbInfo.storeName + " WHERE id = ? LIMIT 1", [n + 1], function(t2, results) {
                    var result = results.rows.length ? results.rows.item(0).key : null;
                    resolve(result);
                  }, function(t2, error) {
                    reject(error);
                  });
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function keys$1(callback) {
            var self2 = this;
            var promise = new Promise$1(function(resolve, reject) {
              self2.ready().then(function() {
                var dbInfo = self2._dbInfo;
                dbInfo.db.transaction(function(t) {
                  tryExecuteSql(t, dbInfo, "SELECT key FROM " + dbInfo.storeName, [], function(t2, results) {
                    var keys2 = [];
                    for (var i = 0; i < results.rows.length; i++) {
                      keys2.push(results.rows.item(i).key);
                    }
                    resolve(keys2);
                  }, function(t2, error) {
                    reject(error);
                  });
                });
              })["catch"](reject);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function getAllStoreNames(db) {
            return new Promise$1(function(resolve, reject) {
              db.transaction(function(t) {
                t.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function(t2, results) {
                  var storeNames = [];
                  for (var i = 0; i < results.rows.length; i++) {
                    storeNames.push(results.rows.item(i).name);
                  }
                  resolve({
                    db,
                    storeNames
                  });
                }, function(t2, error) {
                  reject(error);
                });
              }, function(sqlError) {
                reject(sqlError);
              });
            });
          }
          function dropInstance$1(options, callback) {
            callback = getCallback.apply(this, arguments);
            var currentConfig = this.config();
            options = typeof options !== "function" && options || {};
            if (!options.name) {
              options.name = options.name || currentConfig.name;
              options.storeName = options.storeName || currentConfig.storeName;
            }
            var self2 = this;
            var promise;
            if (!options.name) {
              promise = Promise$1.reject("Invalid arguments");
            } else {
              promise = new Promise$1(function(resolve) {
                var db;
                if (options.name === currentConfig.name) {
                  db = self2._dbInfo.db;
                } else {
                  db = openDatabase(options.name, "", "", 0);
                }
                if (!options.storeName) {
                  resolve(getAllStoreNames(db));
                } else {
                  resolve({
                    db,
                    storeNames: [options.storeName]
                  });
                }
              }).then(function(operationInfo) {
                return new Promise$1(function(resolve, reject) {
                  operationInfo.db.transaction(function(t) {
                    function dropTable(storeName) {
                      return new Promise$1(function(resolve2, reject2) {
                        t.executeSql("DROP TABLE IF EXISTS " + storeName, [], function() {
                          resolve2();
                        }, function(t2, error) {
                          reject2(error);
                        });
                      });
                    }
                    var operations = [];
                    for (var i = 0, len = operationInfo.storeNames.length; i < len; i++) {
                      operations.push(dropTable(operationInfo.storeNames[i]));
                    }
                    Promise$1.all(operations).then(function() {
                      resolve();
                    })["catch"](function(e) {
                      reject(e);
                    });
                  }, function(sqlError) {
                    reject(sqlError);
                  });
                });
              });
            }
            executeCallback(promise, callback);
            return promise;
          }
          var webSQLStorage = {
            _driver: "webSQLStorage",
            _initStorage: _initStorage$1,
            _support: isWebSQLValid(),
            iterate: iterate$1,
            getItem: getItem$1,
            setItem: setItem$1,
            removeItem: removeItem$1,
            clear: clear$1,
            length: length$1,
            key: key$1,
            keys: keys$1,
            dropInstance: dropInstance$1
          };
          function isLocalStorageValid() {
            try {
              return typeof localStorage !== "undefined" && "setItem" in localStorage && // in IE8 typeof localStorage.setItem === 'object'
              !!localStorage.setItem;
            } catch (e) {
              return false;
            }
          }
          function _getKeyPrefix(options, defaultConfig) {
            var keyPrefix = options.name + "/";
            if (options.storeName !== defaultConfig.storeName) {
              keyPrefix += options.storeName + "/";
            }
            return keyPrefix;
          }
          function checkIfLocalStorageThrows() {
            var localStorageTestKey = "_localforage_support_test";
            try {
              localStorage.setItem(localStorageTestKey, true);
              localStorage.removeItem(localStorageTestKey);
              return false;
            } catch (e) {
              return true;
            }
          }
          function _isLocalStorageUsable() {
            return !checkIfLocalStorageThrows() || localStorage.length > 0;
          }
          function _initStorage$2(options) {
            var self2 = this;
            var dbInfo = {};
            if (options) {
              for (var i in options) {
                dbInfo[i] = options[i];
              }
            }
            dbInfo.keyPrefix = _getKeyPrefix(options, self2._defaultConfig);
            if (!_isLocalStorageUsable()) {
              return Promise$1.reject();
            }
            self2._dbInfo = dbInfo;
            dbInfo.serializer = localforageSerializer;
            return Promise$1.resolve();
          }
          function clear$2(callback) {
            var self2 = this;
            var promise = self2.ready().then(function() {
              var keyPrefix = self2._dbInfo.keyPrefix;
              for (var i = localStorage.length - 1; i >= 0; i--) {
                var key2 = localStorage.key(i);
                if (key2.indexOf(keyPrefix) === 0) {
                  localStorage.removeItem(key2);
                }
              }
            });
            executeCallback(promise, callback);
            return promise;
          }
          function getItem$2(key2, callback) {
            var self2 = this;
            key2 = normalizeKey(key2);
            var promise = self2.ready().then(function() {
              var dbInfo = self2._dbInfo;
              var result = localStorage.getItem(dbInfo.keyPrefix + key2);
              if (result) {
                result = dbInfo.serializer.deserialize(result);
              }
              return result;
            });
            executeCallback(promise, callback);
            return promise;
          }
          function iterate$2(iterator, callback) {
            var self2 = this;
            var promise = self2.ready().then(function() {
              var dbInfo = self2._dbInfo;
              var keyPrefix = dbInfo.keyPrefix;
              var keyPrefixLength = keyPrefix.length;
              var length2 = localStorage.length;
              var iterationNumber = 1;
              for (var i = 0; i < length2; i++) {
                var key2 = localStorage.key(i);
                if (key2.indexOf(keyPrefix) !== 0) {
                  continue;
                }
                var value = localStorage.getItem(key2);
                if (value) {
                  value = dbInfo.serializer.deserialize(value);
                }
                value = iterator(value, key2.substring(keyPrefixLength), iterationNumber++);
                if (value !== void 0) {
                  return value;
                }
              }
            });
            executeCallback(promise, callback);
            return promise;
          }
          function key$2(n, callback) {
            var self2 = this;
            var promise = self2.ready().then(function() {
              var dbInfo = self2._dbInfo;
              var result;
              try {
                result = localStorage.key(n);
              } catch (error) {
                result = null;
              }
              if (result) {
                result = result.substring(dbInfo.keyPrefix.length);
              }
              return result;
            });
            executeCallback(promise, callback);
            return promise;
          }
          function keys$2(callback) {
            var self2 = this;
            var promise = self2.ready().then(function() {
              var dbInfo = self2._dbInfo;
              var length2 = localStorage.length;
              var keys2 = [];
              for (var i = 0; i < length2; i++) {
                var itemKey = localStorage.key(i);
                if (itemKey.indexOf(dbInfo.keyPrefix) === 0) {
                  keys2.push(itemKey.substring(dbInfo.keyPrefix.length));
                }
              }
              return keys2;
            });
            executeCallback(promise, callback);
            return promise;
          }
          function length$2(callback) {
            var self2 = this;
            var promise = self2.keys().then(function(keys2) {
              return keys2.length;
            });
            executeCallback(promise, callback);
            return promise;
          }
          function removeItem$2(key2, callback) {
            var self2 = this;
            key2 = normalizeKey(key2);
            var promise = self2.ready().then(function() {
              var dbInfo = self2._dbInfo;
              localStorage.removeItem(dbInfo.keyPrefix + key2);
            });
            executeCallback(promise, callback);
            return promise;
          }
          function setItem$2(key2, value, callback) {
            var self2 = this;
            key2 = normalizeKey(key2);
            var promise = self2.ready().then(function() {
              if (value === void 0) {
                value = null;
              }
              var originalValue = value;
              return new Promise$1(function(resolve, reject) {
                var dbInfo = self2._dbInfo;
                dbInfo.serializer.serialize(value, function(value2, error) {
                  if (error) {
                    reject(error);
                  } else {
                    try {
                      localStorage.setItem(dbInfo.keyPrefix + key2, value2);
                      resolve(originalValue);
                    } catch (e) {
                      if (e.name === "QuotaExceededError" || e.name === "NS_ERROR_DOM_QUOTA_REACHED") {
                        reject(e);
                      }
                      reject(e);
                    }
                  }
                });
              });
            });
            executeCallback(promise, callback);
            return promise;
          }
          function dropInstance$2(options, callback) {
            callback = getCallback.apply(this, arguments);
            options = typeof options !== "function" && options || {};
            if (!options.name) {
              var currentConfig = this.config();
              options.name = options.name || currentConfig.name;
              options.storeName = options.storeName || currentConfig.storeName;
            }
            var self2 = this;
            var promise;
            if (!options.name) {
              promise = Promise$1.reject("Invalid arguments");
            } else {
              promise = new Promise$1(function(resolve) {
                if (!options.storeName) {
                  resolve(options.name + "/");
                } else {
                  resolve(_getKeyPrefix(options, self2._defaultConfig));
                }
              }).then(function(keyPrefix) {
                for (var i = localStorage.length - 1; i >= 0; i--) {
                  var key2 = localStorage.key(i);
                  if (key2.indexOf(keyPrefix) === 0) {
                    localStorage.removeItem(key2);
                  }
                }
              });
            }
            executeCallback(promise, callback);
            return promise;
          }
          var localStorageWrapper = {
            _driver: "localStorageWrapper",
            _initStorage: _initStorage$2,
            _support: isLocalStorageValid(),
            iterate: iterate$2,
            getItem: getItem$2,
            setItem: setItem$2,
            removeItem: removeItem$2,
            clear: clear$2,
            length: length$2,
            key: key$2,
            keys: keys$2,
            dropInstance: dropInstance$2
          };
          var sameValue = function sameValue2(x, y) {
            return x === y || typeof x === "number" && typeof y === "number" && isNaN(x) && isNaN(y);
          };
          var includes = function includes2(array, searchElement) {
            var len = array.length;
            var i = 0;
            while (i < len) {
              if (sameValue(array[i], searchElement)) {
                return true;
              }
              i++;
            }
            return false;
          };
          var isArray = Array.isArray || function(arg) {
            return Object.prototype.toString.call(arg) === "[object Array]";
          };
          var DefinedDrivers = {};
          var DriverSupport = {};
          var DefaultDrivers = {
            INDEXEDDB: asyncStorage,
            WEBSQL: webSQLStorage,
            LOCALSTORAGE: localStorageWrapper
          };
          var DefaultDriverOrder = [DefaultDrivers.INDEXEDDB._driver, DefaultDrivers.WEBSQL._driver, DefaultDrivers.LOCALSTORAGE._driver];
          var OptionalDriverMethods = ["dropInstance"];
          var LibraryMethods = ["clear", "getItem", "iterate", "key", "keys", "length", "removeItem", "setItem"].concat(OptionalDriverMethods);
          var DefaultConfig = {
            description: "",
            driver: DefaultDriverOrder.slice(),
            name: "localforage",
            // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
            // we can use without a prompt.
            size: 4980736,
            storeName: "keyvaluepairs",
            version: 1
          };
          function callWhenReady(localForageInstance, libraryMethod) {
            localForageInstance[libraryMethod] = function() {
              var _args = arguments;
              return localForageInstance.ready().then(function() {
                return localForageInstance[libraryMethod].apply(localForageInstance, _args);
              });
            };
          }
          function extend() {
            for (var i = 1; i < arguments.length; i++) {
              var arg = arguments[i];
              if (arg) {
                for (var _key in arg) {
                  if (arg.hasOwnProperty(_key)) {
                    if (isArray(arg[_key])) {
                      arguments[0][_key] = arg[_key].slice();
                    } else {
                      arguments[0][_key] = arg[_key];
                    }
                  }
                }
              }
            }
            return arguments[0];
          }
          var LocalForage = function() {
            function LocalForage2(options) {
              _classCallCheck(this, LocalForage2);
              for (var driverTypeKey in DefaultDrivers) {
                if (DefaultDrivers.hasOwnProperty(driverTypeKey)) {
                  var driver = DefaultDrivers[driverTypeKey];
                  var driverName = driver._driver;
                  this[driverTypeKey] = driverName;
                  if (!DefinedDrivers[driverName]) {
                    this.defineDriver(driver);
                  }
                }
              }
              this._defaultConfig = extend({}, DefaultConfig);
              this._config = extend({}, this._defaultConfig, options);
              this._driverSet = null;
              this._initDriver = null;
              this._ready = false;
              this._dbInfo = null;
              this._wrapLibraryMethodsWithReady();
              this.setDriver(this._config.driver)["catch"](function() {
              });
            }
            LocalForage2.prototype.config = function config(options) {
              if ((typeof options === "undefined" ? "undefined" : _typeof(options)) === "object") {
                if (this._ready) {
                  return new Error("Can't call config() after localforage has been used.");
                }
                for (var i in options) {
                  if (i === "storeName") {
                    options[i] = options[i].replace(/\W/g, "_");
                  }
                  if (i === "version" && typeof options[i] !== "number") {
                    return new Error("Database version must be a number.");
                  }
                  this._config[i] = options[i];
                }
                if ("driver" in options && options.driver) {
                  return this.setDriver(this._config.driver);
                }
                return true;
              } else if (typeof options === "string") {
                return this._config[options];
              } else {
                return this._config;
              }
            };
            LocalForage2.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
              var promise = new Promise$1(function(resolve, reject) {
                try {
                  var driverName = driverObject._driver;
                  var complianceError = new Error("Custom driver not compliant; see https://mozilla.github.io/localForage/#definedriver");
                  if (!driverObject._driver) {
                    reject(complianceError);
                    return;
                  }
                  var driverMethods = LibraryMethods.concat("_initStorage");
                  for (var i = 0, len = driverMethods.length; i < len; i++) {
                    var driverMethodName = driverMethods[i];
                    var isRequired = !includes(OptionalDriverMethods, driverMethodName);
                    if ((isRequired || driverObject[driverMethodName]) && typeof driverObject[driverMethodName] !== "function") {
                      reject(complianceError);
                      return;
                    }
                  }
                  var configureMissingMethods = function configureMissingMethods2() {
                    var methodNotImplementedFactory = function methodNotImplementedFactory2(methodName) {
                      return function() {
                        var error = new Error("Method " + methodName + " is not implemented by the current driver");
                        var promise2 = Promise$1.reject(error);
                        executeCallback(promise2, arguments[arguments.length - 1]);
                        return promise2;
                      };
                    };
                    for (var _i = 0, _len = OptionalDriverMethods.length; _i < _len; _i++) {
                      var optionalDriverMethod = OptionalDriverMethods[_i];
                      if (!driverObject[optionalDriverMethod]) {
                        driverObject[optionalDriverMethod] = methodNotImplementedFactory(optionalDriverMethod);
                      }
                    }
                  };
                  configureMissingMethods();
                  var setDriverSupport = function setDriverSupport2(support) {
                    if (DefinedDrivers[driverName]) {
                      console.info("Redefining LocalForage driver: " + driverName);
                    }
                    DefinedDrivers[driverName] = driverObject;
                    DriverSupport[driverName] = support;
                    resolve();
                  };
                  if ("_support" in driverObject) {
                    if (driverObject._support && typeof driverObject._support === "function") {
                      driverObject._support().then(setDriverSupport, reject);
                    } else {
                      setDriverSupport(!!driverObject._support);
                    }
                  } else {
                    setDriverSupport(true);
                  }
                } catch (e) {
                  reject(e);
                }
              });
              executeTwoCallbacks(promise, callback, errorCallback);
              return promise;
            };
            LocalForage2.prototype.driver = function driver() {
              return this._driver || null;
            };
            LocalForage2.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
              var getDriverPromise = DefinedDrivers[driverName] ? Promise$1.resolve(DefinedDrivers[driverName]) : Promise$1.reject(new Error("Driver not found."));
              executeTwoCallbacks(getDriverPromise, callback, errorCallback);
              return getDriverPromise;
            };
            LocalForage2.prototype.getSerializer = function getSerializer(callback) {
              var serializerPromise = Promise$1.resolve(localforageSerializer);
              executeTwoCallbacks(serializerPromise, callback);
              return serializerPromise;
            };
            LocalForage2.prototype.ready = function ready(callback) {
              var self2 = this;
              var promise = self2._driverSet.then(function() {
                if (self2._ready === null) {
                  self2._ready = self2._initDriver();
                }
                return self2._ready;
              });
              executeTwoCallbacks(promise, callback, callback);
              return promise;
            };
            LocalForage2.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
              var self2 = this;
              if (!isArray(drivers)) {
                drivers = [drivers];
              }
              var supportedDrivers = this._getSupportedDrivers(drivers);
              function setDriverToConfig() {
                self2._config.driver = self2.driver();
              }
              function extendSelfWithDriver(driver) {
                self2._extend(driver);
                setDriverToConfig();
                self2._ready = self2._initStorage(self2._config);
                return self2._ready;
              }
              function initDriver(supportedDrivers2) {
                return function() {
                  var currentDriverIndex = 0;
                  function driverPromiseLoop() {
                    while (currentDriverIndex < supportedDrivers2.length) {
                      var driverName = supportedDrivers2[currentDriverIndex];
                      currentDriverIndex++;
                      self2._dbInfo = null;
                      self2._ready = null;
                      return self2.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
                    }
                    setDriverToConfig();
                    var error = new Error("No available storage method found.");
                    self2._driverSet = Promise$1.reject(error);
                    return self2._driverSet;
                  }
                  return driverPromiseLoop();
                };
              }
              var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function() {
                return Promise$1.resolve();
              }) : Promise$1.resolve();
              this._driverSet = oldDriverSetDone.then(function() {
                var driverName = supportedDrivers[0];
                self2._dbInfo = null;
                self2._ready = null;
                return self2.getDriver(driverName).then(function(driver) {
                  self2._driver = driver._driver;
                  setDriverToConfig();
                  self2._wrapLibraryMethodsWithReady();
                  self2._initDriver = initDriver(supportedDrivers);
                });
              })["catch"](function() {
                setDriverToConfig();
                var error = new Error("No available storage method found.");
                self2._driverSet = Promise$1.reject(error);
                return self2._driverSet;
              });
              executeTwoCallbacks(this._driverSet, callback, errorCallback);
              return this._driverSet;
            };
            LocalForage2.prototype.supports = function supports(driverName) {
              return !!DriverSupport[driverName];
            };
            LocalForage2.prototype._extend = function _extend(libraryMethodsAndProperties) {
              extend(this, libraryMethodsAndProperties);
            };
            LocalForage2.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
              var supportedDrivers = [];
              for (var i = 0, len = drivers.length; i < len; i++) {
                var driverName = drivers[i];
                if (this.supports(driverName)) {
                  supportedDrivers.push(driverName);
                }
              }
              return supportedDrivers;
            };
            LocalForage2.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
              for (var i = 0, len = LibraryMethods.length; i < len; i++) {
                callWhenReady(this, LibraryMethods[i]);
              }
            };
            LocalForage2.prototype.createInstance = function createInstance(options) {
              return new LocalForage2(options);
            };
            return LocalForage2;
          }();
          var localforage_js = new LocalForage();
          module3.exports = localforage_js;
        }, { "3": 3 }] }, {}, [4])(4);
      });
    }
  });

  // app/scripts/common/index.js
  var import_localforage = __toESM(require_localforage(), 1);

  // app/scripts/common/function/addEvent.js
  function addEvent(evt, selector, handler) {
    evt.split(" ").forEach((event) => {
      document.addEventListener(event, function(event2) {
        if (event2.target.matches(selector + ", " + selector + " *")) {
          handler.apply(event2.target.closest(selector), arguments);
        }
      }, false);
    });
  }

  // app/scripts/common/function/debounceTime.js
  function debounceTime(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  // app/scripts/common/function/serializeForm.js
  function serializeForm(form) {
    const obj2 = {};
    const formData = new FormData(form);
    let properties = {};
    let hasProperties = false;
    for (const key of formData.keys()) {
      if (key.includes("properties")) {
        if (formData.get(key).length) {
          let newKey = key.slice(0, key.length - 1);
          newKey = newKey.replace("properties[", "");
          properties = Object.assign(properties, {
            [newKey]: formData.get(key)
          });
          hasProperties = true;
        }
      } else {
        obj2[key] = formData.get(key);
      }
    }
    if (hasProperties)
      obj2.properties = properties;
    console.log(obj2);
    return JSON.stringify(obj2);
  }

  // app/scripts/common/function/resizeObserver.js
  function resizeObserver(selector, callback, debounceTimeout = 300) {
    const { debounceTime: debounceTime2 } = theme;
    let lastWidth = selector.clientWidth;
    const debounce = debounceTime2((e) => {
      let newestWidth = selector.clientWidth;
      if (newestWidth == lastWidth) return;
      callback.apply(selector);
      lastWidth = newestWidth;
    }, debounceTimeout);
    if ("ResizeObserver" in window) {
      const resizeObserver2 = new ResizeObserver((entries) => {
        debounce.call(selector);
      });
      resizeObserver2.observe(selector);
    } else {
      window.addEventListener("resize", () => debounce.bind(selector));
    }
  }

  // app/scripts/common/function/inViewPort.js
  function inViewPort(el, callback, once = false) {
    if (!el || typeof callback !== "function") return;
    const options = {
      root: null,
      // viewport
      rootMargin: "0px",
      threshold: 0
      // trigger when element first appears in viewport
    };
    const observer = new IntersectionObserver((entries) => {
      const isIntersecting = entries[0].isIntersecting;
      callback(isIntersecting, entries);
      if (isIntersecting && once) {
        observer.disconnect();
      }
    }, options);
    observer.observe(el);
    return () => observer.disconnect();
  }

  // app/scripts/common/function/localStorage.js
  var storage = {
    get: function(key) {
      const item = localStorage.getItem(key);
      if (!item) return null;
      const { value, expiry } = JSON.parse(item);
      if (expiry && Date.now() > expiry) {
        this.delete(key);
        return null;
      }
      return value;
    },
    set: function(key, value, expiryDays = 1) {
      const expiry = expiryDays ? Date.now() + expiryDays * 24 * 60 * 60 * 1e3 : null;
      const item = JSON.stringify({ value, expiry });
      localStorage.setItem(key, item);
    },
    delete: function(key) {
      localStorage.removeItem(key);
    }
  };
  var localStorage_default = storage;

  // app/scripts/common/index.js
  window.theme = Object.assign(window.theme, {
    addEvent,
    localforage: import_localforage.default,
    storage: localStorage_default,
    serializeForm,
    debounceTime,
    resizeObserver,
    inViewPort,
    // , request: (method = 'POST', type = 'json') => {
    //   return {
    //     method: method,
    //     credentials: 'same-origin',
    //     headers: {
    //       'X-Requested-With': 'XMLHttpRequest',
    //       'Content-Type': `application/${type};`
    //     }
    //   }
    // }
    // , toggleSticky: function (hide = true) {
    //   if (hide) {
    //     document.querySelector('sticky-header')?.classList.add('tnone')
    //     return
    //   }
    //   document.querySelector('sticky-header')?.classList.remove('tnone');
    // }
    async get(key) {
      const data = await theme.localforage.getItem(key);
      if (!data) return null;
      if (data.expiry && Date.now() > data.expiry) {
        await theme.localforage.removeItem(key);
        return null;
      }
      return data.value || data;
    },
    set(key, value, daysUntilExpiry = false, callback = false) {
      const expiry = daysUntilExpiry ? Date.now() + daysUntilExpiry * 864e5 : null;
      return theme.localforage.setItem(key, { value, expiry }, typeof callback === "function" ? callback : void 0);
    }
  });

  // app/scripts/common/events/calculateScrollBarWidth.js
  function scrollBarWidth() {
    return window.innerWidth - document.documentElement.offsetWidth;
  }
  document.body.style.setProperty("--scrollbar-width", scrollBarWidth() + "px");
  window.addEventListener("resize", () => {
    document.body.style.setProperty("--scrollbar-width", scrollBarWidth() + "px");
  });

  // app/scripts/common/events/toggleClass.js
  var { addEvent: addEvent2 } = theme;
  addEvent2("click", ".jsToggleClass", (e) => {
    const el = e.target.closest(".jsToggleClass");
    const target = document.querySelectorAll(el.dataset.target || null);
    console.log("el :>> ", el.dataset);
    if (!target.length) return;
    let { className, classRemove, classRule, classEvent } = el.dataset;
    if (classEvent == "none") {
      e.preventDefault();
      e.stopPropagation();
    }
    target.forEach((i) => {
      switch (classRule) {
        case "add":
          i.classList.add(...className.split(","));
          break;
        case "remove":
          i.classList.remove(...className.split(","));
          break;
        default:
          className.split(",").forEach((c) => i.classList.toggle(c));
      }
      if (classRemove) {
        i.classList.remove(...classRemove.split(","));
      }
    });
  });

  // app/scripts/common/events/togglePopup.js
  var { addEvent: addEvent3, loadTemplate } = theme;
  addEvent3("click", ".jsTogglePopup", (e) => {
    const el = e.target.closest(".jsTogglePopup");
    const { control: popupControlId, id: popupId } = el.dataset;
    let popup = null;
    if (popupControlId)
      popup = document.querySelector(`.popup-component[data-control="${popupControlId}"],${popupControlId}`);
    else if (popupId)
      popup = document.querySelector(`.popup-component[id="${popupId}"],${popupId}`);
    if (!popup) return;
    if (popupControlId == "#cartDrawer" && theme.settings.cartStyle == "drawer_desktop" && !window.matchMedia("(min-width: 750px)").matches || popupControlId == "#filterPopup") {
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    el.classList.toggle("active");
    popup.isOpen ? popup.close() : popup.open();
  });
  addEvent3("click", ".jsPopupClose", (e) => {
    e.preventDefault();
    const el = e.target;
    const popup = el.closest(".popup-component");
    if (!popup) return;
    popup.close();
    document.querySelectorAll(`.jsTogglePopup[data-control="${popup.dataset.control}"]`)?.forEach((el2) => el2.classList.remove("active"));
  });

  // app/scripts/common/events/loadTemplate.js
  var { addEvent: addEvent4 } = theme;
  addEvent4("click", ".jsTemplate", (e) => {
    const node = e.target.closest(".jsTemplate");
    const template = document.querySelector(node.dataset.template);
    e.preventDefault();
    e.stopPropagation();
    template.tagName == "TEMPLATE" && Array.from(template.content.children)?.forEach((child) => {
      template.insertAdjacentElement("beforebegin", child);
      if (template.id == "mobileMenuTemplate") {
        document.querySelectorAll(".jsTriggerSearch").forEach((e2) => {
          e2.addEventListener("click", () => {
            const isIos = () => /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
            document.querySelector(".search-btn").click();
            if (isIos()) {
              try {
                document.querySelector("#search-field").focus();
                console.log("Synchronous focus attempted on iOS");
                requestAnimationFrame(() => {
                  if (document.activeElement !== searchField) {
                    document.querySelector("#search-field").focus();
                    console.log("Fallback focus attempted on iOS");
                  }
                });
              } catch (err) {
                console.error("Focus error on iOS:", err);
              }
            } else {
              document.querySelector("#search-field").focus();
            }
          });
        });
      }
    });
    if (template.tagName == "NOSCRIPT") {
      const div = document.createElement("div");
      div.innerHTML = template.innerHTML;
      template.insertAdjacentElement("beforebegin", div);
    }
    template.remove();
    node.classList.remove("jsTemplate");
    node.removeAttribute("data-template");
    setTimeout(() => {
      node.click();
    }, 300);
  });

  // app/scripts/common/events/keyEvents.js
  document.addEventListener("keyup", (e) => {
    e.key == `Escape` && document.querySelectorAll("details[open]")?.forEach((item) => item.removeAttribute("open"));
  });

  // app/scripts/common/function/cart.js
  window.cartForm = class extends HTMLElement {
    constructor() {
      super();
      this.sections = [
        {
          key: "section",
          section: "cart-section"
        },
        {
          key: "count",
          section: "cart-live-region-text"
        }
      ];
      if (window.theme.routes.pageType == "cart") {
        const cartRecomendation = document.querySelector(".js-cart-complete-the-look");
        if (cartRecomendation) {
          this.sections = [
            ...this.sections,
            {
              key: "cart-complete-the-look",
              section: cartRecomendation.closest("[data-section-id]").getAttribute("data-section-id")
            }
          ];
        }
      }
    }
    sectionList(section) {
      if (section) {
        const callSection = section.split(",");
        return this.sections.filter((i) => callSection.includes(i.key)).map((i) => i.section).join(",");
      }
      return this.sections.map((i) => i.section).join(",");
    }
    getHeader(formData) {
      if (!(formData instanceof FormData)) {
        return { "Content-Type": "application/json" };
      } else return { "X-Requested-With": "XMLHttpRequest" };
    }
    async postCart(type, data, callback = null, effect = "default", delay = 10, beforeReRenderCallback = null) {
      type != "update" && window.addEventListener("cart:update", this.update.bind(this), { once: true });
      if (type == "add") this.loadingState = true;
      let status = true;
      let response = await fetch(`${theme.routes.cartUrl}/${type}.js`, {
        method: "POST",
        headers: this.getHeader(data),
        body: data
      });
      response = await response.json();
      if (type == "update") return;
      if (type == "add") this.loadingState = false;
      if (response.status) {
        console.error(response);
        this.notify(response.description || response.message);
        status = false;
        response.sections = await this.refresh();
      }
      let newCartJson = null;
      if (type == "add") {
        const newCart = await fetch(`${theme.routes.cartUrl}.js`);
        newCartJson = await newCart.json();
      }
      beforeReRenderCallback != null && beforeReRenderCallback(response);
      setTimeout(() => {
        window.dispatchEvent(
          new CustomEvent("cart:update", {
            detail: {
              sections: response.sections,
              status,
              cart: response,
              effect,
              type,
              newCart: newCartJson
            }
          })
        );
        callback != null && callback(response);
      }, delay);
    }
    async refresh() {
      let response = await fetch(`${location.pathname}?sections=${this.sectionList()}`);
      response = await response.json();
      return response;
    }
    update(evt) {
      const {
        detail: { sections, status, cart, effect, type, cssSelector = "", newCart = null }
      } = evt;
      const refreshAll = !cssSelector;
      console.log("type::", type);
      let cart_item_count;
      if (typeof cart.item_count !== "undefined") {
        cart_item_count = cart.item_count;
      } else if (newCart && typeof newCart.item_count !== "undefined") {
        cart_item_count = newCart.item_count;
      } else {
        for (const [section, html] of Object.entries(sections)) {
          const key = this.sections.find((i) => i.section == section)?.key || section;
          if (key == "count") {
            cart_item_count = +html.split("<!-- split -->")[1].trim();
            break;
          }
        }
      }
      for (const [section, html] of Object.entries(sections)) {
        const key = this.sections.find((i) => i.section == section)?.key || section;
        switch (key) {
          case "count":
            this.updateCartCount = html.split("<!-- split -->")[1];
            break;
          case "noti-success":
            if (type == "add") {
              let div1 = document.createElement("div");
              div1.innerHTML = html;
              Array.from(div1.querySelector(".shopify-section").children).forEach((el) => {
                document.body.insertAdjacentElement("beforeend", el);
              });
            }
            break;
          case "cart-complete-the-look":
            let div2 = document.createElement("div");
            div2.innerHTML = html;
            div2.querySelectorAll(".jsCartUpdate").forEach((newItem) => {
              const selector = Array.from(newItem.classList).map((cls) => `.${CSS.escape(cls)}`).join("");
              const currentItem = document.querySelector(selector);
              if (currentItem) {
                currentItem.innerHTML = newItem.innerHTML;
              }
            });
            break;
          default:
            let div = document.createElement("div");
            div.innerHTML = html;
            const cartComponent = document.querySelector("cart-component");
            const updateContentSelector = (cssSelector + " .jsCartUpdate").trim();
            const updateAttributeSelector = (cssSelector + " .jsCartUpdateAttribute").trim();
            div.querySelectorAll(updateContentSelector).forEach((newItem) => {
              const selector = Array.from(newItem.classList).map((cls) => `.${CSS.escape(cls)}`).join("");
              const currentItem = document.querySelector(selector);
              if (currentItem) {
                currentItem.innerHTML = newItem.innerHTML;
              }
            });
            div.querySelectorAll(updateAttributeSelector).forEach((newItem) => {
              const selector = Array.from(newItem.classList).map((cls) => `.${CSS.escape(cls)}`).join("");
              const currentItem = document.querySelector(selector);
              if (currentItem) {
                newItem.getAttributeNames().forEach((name) => {
                  if (name === "style") {
                    for (let i = 0; i < newItem.style.length; i++) {
                      const styleName = newItem.style[i];
                      const styleValue = newItem.style.getPropertyValue(styleName);
                      currentItem.style.setProperty(styleName, styleValue);
                    }
                  } else {
                    currentItem.setAttribute(name, newItem.getAttribute(name));
                  }
                });
              }
            });
            cartComponent.classList.toggle("is-empty", cart_item_count == 0);
            if (cart_item_count > 0) {
              const dynamicGifting = document.querySelector("progress-bar-dynamic-gifting");
              dynamicGifting?.setProgressValue();
            }
        }
      }
      if (refreshAll) {
        if (typeof window.affirm?.ui?.refresh === "function") {
          window.affirm.ui.refresh();
        }
        if (window.bcpo) {
          if (type == "refresh") {
            const { sections: sections2, ...cart2 } = cart;
            window.bcpo.cart = window.bcpo.cart2 = cart2;
          } else if (type == "add") {
            window.bcpo.cart = window.bcpo.cart2 = newCart;
          } else {
            const { sections: sections2, items_added, items_removed, ...cart2 } = cart;
            window.bcpo.cart = window.bcpo.cart2 = cart2;
          }
          window.bcpo.fixCartPrices(
            true,
            `[name="checkout"], a[href^="/checkout"], a[href="/account/login"].cart__submit, button[type="submit"].btn-order, a.btn.cart__checkout, a.cart__submit, input.action_button[value="Checkout"], .wc-proceed-to-checkout button, #cart_form .buttons .btn-primary, a.cart_adev_o, [data-limoniapps-discountninja-checkoutlink], form > button.checkout-button, button.btn_checkout, button.checkout-btn`
          );
          window.discountOnCartProApp?.updateWidgets();
          const checkoutBtns = document.querySelectorAll('[name="checkout"]');
          checkoutBtns.forEach((btn) => {
            btn.disabled = false;
          });
        }
      }
      console.log("cart:ready", newCart || cart);
      window.dispatchEvent(
        new CustomEvent("cart:ready", {
          detail: {
            status,
            cart: newCart || cart,
            type
          }
        })
      );
    }
    async notify(msg) {
      const cartNotify = "cart-notify";
      let response = await fetch(`${theme.routes.searchUrl}?q=${encodeURI(msg)}&section_id=${cartNotify}`);
      response = await response.text();
      let div = document.createElement("div");
      div.innerHTML = response;
      Array.from(div.querySelector(".shopify-section").children).forEach((el) => {
        document.body.insertAdjacentElement("beforeend", el);
      });
    }
    set loadingState(bool) {
      const buttons = Array.from(this.form.elements).filter((button) => button.type === "submit");
      this.loadingCustomText = this.loadingCustomText || typeof this.getAttribute == "function" && this.getAttribute("data-loading-custom-text") || "";
      if (bool) {
        if (!this.loading) {
          buttons.forEach((button) => {
            button.setAttribute("aria-busy", true);
            button.classList.add("disabled");
            button.HTMLTemp = button.innerHTML;
            if (this.loadingCustomText) {
              button.innerHTML = this.loadingCustomText;
            } else {
              button.innerHTML = document.querySelector("#svg_loading").innerHTML;
            }
          });
          this.loading = true;
        }
      } else {
        buttons.forEach((button) => {
          button.removeAttribute("aria-busy");
          button.classList.remove("disabled");
          button.innerHTML = button.HTMLTemp;
          button.HTMLTemp = null;
        });
        this.loading = false;
      }
    }
    set updateCartCount(value) {
      document.querySelectorAll(".jsCartCount")?.forEach((item) => item.setAttribute("data-count", value));
    }
  };

  // app/scripts/common/function/currencies.js
  var multiCurrency = {};
  var moneyFormat = theme.settings.moneyFormat;
  multiCurrency.moneyFormats = {
    USD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} USD"
    },
    EUR: {
      money_format: "&euro;{{amount}}",
      money_with_currency_format: "&euro;{{amount}} EUR"
    },
    GBP: {
      money_format: "&pound;{{amount}}",
      money_with_currency_format: "&pound;{{amount}} GBP"
    },
    CAD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} CAD"
    },
    ALL: {
      money_format: "Lek {{amount}}",
      money_with_currency_format: "Lek {{amount}} ALL"
    },
    DZD: {
      money_format: "DA {{amount}}",
      money_with_currency_format: "DA {{amount}} DZD"
    },
    AOA: {
      money_format: "Kz{{amount}}",
      money_with_currency_format: "Kz{{amount}} AOA"
    },
    ARS: {
      money_format: "${{amount_with_comma_separator}}",
      money_with_currency_format: "${{amount_with_comma_separator}} ARS"
    },
    AMD: {
      money_format: "{{amount}} AMD",
      money_with_currency_format: "{{amount}} AMD"
    },
    AWG: {
      money_format: "Afl{{amount}}",
      money_with_currency_format: "Afl{{amount}} AWG"
    },
    AUD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} AUD"
    },
    BBD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} Bds"
    },
    AZN: {
      money_format: "m.{{amount}}",
      money_with_currency_format: "m.{{amount}} AZN"
    },
    BDT: {
      money_format: "Tk {{amount}}",
      money_with_currency_format: "Tk {{amount}} BDT"
    },
    BSD: {
      money_format: "BS${{amount}}",
      money_with_currency_format: "BS${{amount}} BSD"
    },
    BHD: {
      money_format: "{{amount}}0 BD",
      money_with_currency_format: "{{amount}}0 BHD"
    },
    BYR: {
      money_format: "Br {{amount}}",
      money_with_currency_format: "Br {{amount}} BYR"
    },
    BZD: {
      money_format: "BZ${{amount}}",
      money_with_currency_format: "BZ${{amount}} BZD"
    },
    BTN: {
      money_format: "Nu {{amount}}",
      money_with_currency_format: "Nu {{amount}} BTN"
    },
    BAM: {
      money_format: "KM {{amount_with_comma_separator}}",
      money_with_currency_format: "KM {{amount_with_comma_separator}} BAM"
    },
    BRL: {
      money_format: "R$ {{amount_with_comma_separator}}",
      money_with_currency_format: "R$ {{amount_with_comma_separator}} BRL"
    },
    BOB: {
      money_format: "Bs{{amount_with_comma_separator}}",
      money_with_currency_format: "Bs{{amount_with_comma_separator}} BOB"
    },
    BWP: {
      money_format: "P{{amount}}",
      money_with_currency_format: "P{{amount}} BWP"
    },
    BND: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} BND"
    },
    BGN: {
      money_format: "{{amount}} \u043B\u0432",
      money_with_currency_format: "{{amount}} \u043B\u0432 BGN"
    },
    MMK: {
      money_format: "K{{amount}}",
      money_with_currency_format: "K{{amount}} MMK"
    },
    KHR: {
      money_format: "KHR{{amount}}",
      money_with_currency_format: "KHR{{amount}}"
    },
    KYD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} KYD"
    },
    XAF: {
      money_format: "FCFA{{amount}}",
      money_with_currency_format: "FCFA{{amount}} XAF"
    },
    CLP: {
      money_format: "${{amount_no_decimals}}",
      money_with_currency_format: "${{amount_no_decimals}} CLP"
    },
    CNY: {
      money_format: "&#165;{{amount}}",
      money_with_currency_format: "&#165;{{amount}} CNY"
    },
    COP: {
      money_format: "${{amount_with_comma_separator}}",
      money_with_currency_format: "${{amount_with_comma_separator}} COP"
    },
    CRC: {
      money_format: "&#8353; {{amount_with_comma_separator}}",
      money_with_currency_format: "&#8353; {{amount_with_comma_separator}} CRC"
    },
    HRK: {
      money_format: "{{amount_with_comma_separator}} kn",
      money_with_currency_format: "{{amount_with_comma_separator}} kn HRK"
    },
    CZK: {
      money_format: "{{amount_with_comma_separator}} K&#269;",
      money_with_currency_format: "{{amount_with_comma_separator}} K&#269;"
    },
    DKK: {
      money_format: "{{amount_with_comma_separator}}",
      money_with_currency_format: "kr.{{amount_with_comma_separator}}"
    },
    DOP: {
      money_format: "RD$ {{amount}}",
      money_with_currency_format: "RD$ {{amount}}"
    },
    XCD: {
      money_format: "${{amount}}",
      money_with_currency_format: "EC${{amount}}"
    },
    EGP: {
      money_format: "LE {{amount}}",
      money_with_currency_format: "LE {{amount}} EGP"
    },
    ETB: {
      money_format: "Br{{amount}}",
      money_with_currency_format: "Br{{amount}} ETB"
    },
    XPF: {
      money_format: "{{amount_no_decimals_with_comma_separator}} XPF",
      money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} XPF"
    },
    FJD: {
      money_format: "${{amount}}",
      money_with_currency_format: "FJ${{amount}}"
    },
    GMD: {
      money_format: "D {{amount}}",
      money_with_currency_format: "D {{amount}} GMD"
    },
    GHS: {
      money_format: "GH&#8373;{{amount}}",
      money_with_currency_format: "GH&#8373;{{amount}}"
    },
    GTQ: {
      money_format: "Q{{amount}}",
      money_with_currency_format: "{{amount}} GTQ"
    },
    GYD: {
      money_format: "G${{amount}}",
      money_with_currency_format: "${{amount}} GYD"
    },
    GEL: {
      money_format: "{{amount}} GEL",
      money_with_currency_format: "{{amount}} GEL"
    },
    HNL: {
      money_format: "L {{amount}}",
      money_with_currency_format: "L {{amount}} HNL"
    },
    HKD: {
      money_format: "${{amount}}",
      money_with_currency_format: "HK${{amount}}"
    },
    HUF: {
      money_format: "{{amount_no_decimals_with_comma_separator}}",
      money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} Ft"
    },
    ISK: {
      money_format: "{{amount_no_decimals}} kr",
      money_with_currency_format: "{{amount_no_decimals}} kr ISK"
    },
    INR: {
      money_format: "Rs. {{amount}}",
      money_with_currency_format: "Rs. {{amount}}"
    },
    IDR: {
      money_format: "{{amount_with_comma_separator}}",
      money_with_currency_format: "Rp {{amount_with_comma_separator}}"
    },
    ILS: {
      money_format: "{{amount}} NIS",
      money_with_currency_format: "{{amount}} NIS"
    },
    JMD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} JMD"
    },
    JPY: {
      money_format: "&#165;{{amount_no_decimals}}",
      money_with_currency_format: "&#165;{{amount_no_decimals}} JPY"
    },
    JEP: {
      money_format: "&pound;{{amount}}",
      money_with_currency_format: "&pound;{{amount}} JEP"
    },
    JOD: {
      money_format: "{{amount}}0 JD",
      money_with_currency_format: "{{amount}}0 JOD"
    },
    KZT: {
      money_format: "{{amount}} KZT",
      money_with_currency_format: "{{amount}} KZT"
    },
    KES: {
      money_format: "KSh{{amount}}",
      money_with_currency_format: "KSh{{amount}}"
    },
    KWD: {
      money_format: "{{amount}}0 KD",
      money_with_currency_format: "{{amount}}0 KWD"
    },
    KGS: {
      money_format: "\u043B\u0432{{amount}}",
      money_with_currency_format: "\u043B\u0432{{amount}}"
    },
    LVL: {
      money_format: "Ls {{amount}}",
      money_with_currency_format: "Ls {{amount}} LVL"
    },
    LBP: {
      money_format: "L&pound;{{amount}}",
      money_with_currency_format: "L&pound;{{amount}} LBP"
    },
    LTL: {
      money_format: "{{amount}} Lt",
      money_with_currency_format: "{{amount}} Lt"
    },
    MGA: {
      money_format: "Ar {{amount}}",
      money_with_currency_format: "Ar {{amount}} MGA"
    },
    MKD: {
      money_format: "\u0434\u0435\u043D {{amount}}",
      money_with_currency_format: "\u0434\u0435\u043D {{amount}} MKD"
    },
    MOP: {
      money_format: "MOP${{amount}}",
      money_with_currency_format: "MOP${{amount}}"
    },
    MVR: {
      money_format: "Rf{{amount}}",
      money_with_currency_format: "Rf{{amount}} MRf"
    },
    MXN: {
      money_format: "$ {{amount}}",
      money_with_currency_format: "$ {{amount}} MXN"
    },
    MYR: {
      money_format: "RM{{amount}} MYR",
      money_with_currency_format: "RM{{amount}} MYR"
    },
    MUR: {
      money_format: "Rs {{amount}}",
      money_with_currency_format: "Rs {{amount}} MUR"
    },
    MDL: {
      money_format: "{{amount}} MDL",
      money_with_currency_format: "{{amount}} MDL"
    },
    MAD: {
      money_format: "{{amount}} dh",
      money_with_currency_format: "Dh {{amount}} MAD"
    },
    MNT: {
      money_format: "{{amount_no_decimals}} &#8366",
      money_with_currency_format: "{{amount_no_decimals}} MNT"
    },
    MZN: {
      money_format: "{{amount}} Mt",
      money_with_currency_format: "Mt {{amount}} MZN"
    },
    NAD: {
      money_format: "N${{amount}}",
      money_with_currency_format: "N${{amount}} NAD"
    },
    NPR: {
      money_format: "Rs{{amount}}",
      money_with_currency_format: "Rs{{amount}} NPR"
    },
    ANG: {
      money_format: "&fnof;{{amount}}",
      money_with_currency_format: "{{amount}} NA&fnof;"
    },
    NZD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} NZD"
    },
    NIO: {
      money_format: "C${{amount}}",
      money_with_currency_format: "C${{amount}} NIO"
    },
    NGN: {
      money_format: "&#8358;{{amount}}",
      money_with_currency_format: "&#8358;{{amount}} NGN"
    },
    NOK: {
      money_format: "kr {{amount_with_comma_separator}}",
      money_with_currency_format: "kr {{amount_with_comma_separator}} NOK"
    },
    OMR: {
      money_format: "{{amount_with_comma_separator}} OMR",
      money_with_currency_format: "{{amount_with_comma_separator}} OMR"
    },
    PKR: {
      money_format: "Rs.{{amount}}",
      money_with_currency_format: "Rs.{{amount}} PKR"
    },
    PGK: {
      money_format: "K {{amount}}",
      money_with_currency_format: "K {{amount}} PGK"
    },
    PYG: {
      money_format: "Gs. {{amount_no_decimals_with_comma_separator}}",
      money_with_currency_format: "Gs. {{amount_no_decimals_with_comma_separator}} PYG"
    },
    PEN: {
      money_format: "S/. {{amount}}",
      money_with_currency_format: "S/. {{amount}} PEN"
    },
    PHP: {
      money_format: "&#8369;{{amount}}",
      money_with_currency_format: "&#8369;{{amount}} PHP"
    },
    PLN: {
      money_format: "{{amount_with_comma_separator}} zl",
      money_with_currency_format: "{{amount_with_comma_separator}} zl PLN"
    },
    QAR: {
      money_format: "QAR {{amount_with_comma_separator}}",
      money_with_currency_format: "QAR {{amount_with_comma_separator}}"
    },
    RON: {
      money_format: "{{amount_with_comma_separator}} lei",
      money_with_currency_format: "{{amount_with_comma_separator}} lei RON"
    },
    RUB: {
      money_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",
      money_with_currency_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB"
    },
    RWF: {
      money_format: "{{amount_no_decimals}} RF",
      money_with_currency_format: "{{amount_no_decimals}} RWF"
    },
    WST: {
      money_format: "WS$ {{amount}}",
      money_with_currency_format: "WS$ {{amount}} WST"
    },
    SAR: {
      money_format: "{{amount}} SR",
      money_with_currency_format: "{{amount}} SAR"
    },
    STD: {
      money_format: "Db {{amount}}",
      money_with_currency_format: "Db {{amount}} STD"
    },
    RSD: {
      money_format: "{{amount}} RSD",
      money_with_currency_format: "{{amount}} RSD"
    },
    SCR: {
      money_format: "Rs {{amount}}",
      money_with_currency_format: "Rs {{amount}} SCR"
    },
    SGD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} SGD"
    },
    SYP: {
      money_format: "S&pound;{{amount}}",
      money_with_currency_format: "S&pound;{{amount}} SYP"
    },
    ZAR: {
      money_format: "R {{amount}}",
      money_with_currency_format: "R {{amount}} ZAR"
    },
    KRW: {
      money_format: "&#8361;{{amount_no_decimals}}",
      money_with_currency_format: "&#8361;{{amount_no_decimals}} KRW"
    },
    LKR: {
      money_format: "Rs {{amount}}",
      money_with_currency_format: "Rs {{amount}} LKR"
    },
    SEK: {
      money_format: "{{amount_no_decimals}} kr",
      money_with_currency_format: "{{amount_no_decimals}} kr SEK"
    },
    CHF: {
      money_format: "SFr. {{amount}}",
      money_with_currency_format: "SFr. {{amount}} CHF"
    },
    TWD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} TWD"
    },
    THB: {
      money_format: "{{amount}} &#xe3f;",
      money_with_currency_format: "{{amount}} &#xe3f; THB"
    },
    TZS: {
      money_format: "{{amount}} TZS",
      money_with_currency_format: "{{amount}} TZS"
    },
    TTD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} TTD"
    },
    TND: {
      money_format: "{{amount}}",
      money_with_currency_format: "{{amount}} DT"
    },
    TRY: {
      money_format: "{{amount}}TL",
      money_with_currency_format: "{{amount}}TL"
    },
    UGX: {
      money_format: "Ush {{amount_no_decimals}}",
      money_with_currency_format: "Ush {{amount_no_decimals}} UGX"
    },
    UAH: {
      money_format: "\u20B4{{amount}}",
      money_with_currency_format: "\u20B4{{amount}} UAH"
    },
    AED: {
      money_format: "Dhs. {{amount}}",
      money_with_currency_format: "Dhs. {{amount}} AED"
    },
    UYU: {
      money_format: "${{amount_with_comma_separator}}",
      money_with_currency_format: "${{amount_with_comma_separator}} UYU"
    },
    VUV: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}}VT"
    },
    VEF: {
      money_format: "Bs. {{amount_with_comma_separator}}",
      money_with_currency_format: "Bs. {{amount_with_comma_separator}} VEF"
    },
    VND: {
      money_format: "{{amount_no_decimals_with_comma_separator}}&#8363;",
      money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} VND"
    },
    XBT: {
      money_format: "{{amount_no_decimals}} BTC",
      money_with_currency_format: "{{amount_no_decimals}} BTC"
    },
    XOF: {
      money_format: "CFA{{amount}}",
      money_with_currency_format: "CFA{{amount}} XOF"
    },
    ZMW: {
      money_format: "K{{amount_no_decimals_with_comma_separator}}",
      money_with_currency_format: "ZMW{{amount_no_decimals_with_comma_separator}}"
    }
  };
  multiCurrency.formatMoney = function(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    let value = "";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;
    function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      const parts = number.split(".");
      const dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        `$1${thousands}`
      );
      const centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  };
  Object.assign(Number.prototype, {
    toCurrency: function() {
      return multiCurrency.formatMoney(this, moneyFormat);
    }
  });
  Object.assign(String.prototype, {
    toCurrency: function() {
      return multiCurrency.formatMoney(this, moneyFormat);
    }
  });
  var currencies_default = multiCurrency;

  // app/scripts/common/component/priceComponent.js
  var moneyElement = class extends HTMLElement {
    constructor() {
      super();
      this.value = +this.dataset.value;
      this.content = this.lastElementChild || this;
    }
    get() {
      return this.value;
    }
    set(value = null, money_without_trailing_zeros = false) {
      this.value = value;
      this.dataset.value = value;
      if (value == null) {
        this.content.innerHTML = "";
        return;
      }
      let currencyFormat = this.dataset.format || theme.settings.currencyFormat || "money_format";
      let f = currencies_default.moneyFormats[theme.settings.currency][currencyFormat] || "{{amount}}";
      let newPrice = currencies_default.formatMoney(value, f);
      this.content.innerHTML = this.removeTrailingZeros(newPrice);
    }
    removeTrailingZeros(currency) {
      if (currency.endsWith(".00") || currency.endsWith(",00")) {
        return currency.slice(0, -3);
      }
      return currency;
    }
  };
  customElements.define("price-component", moneyElement);

  // app/scripts/common/component/popupComponent.js
  var { inViewPort: inViewPort2, addEvent: addEvent5 } = theme;
  var customElementsName = "popup-component";
  window.getFocusableElements = (container) => {
    return Array.from(
      container.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
    );
  };
  !window.customElements.get(customElementsName) && window.customElements.define(
    customElementsName,
    class extends HTMLElement {
      constructor() {
        super();
        this.isOpen = false;
        this.config = {
          activeClass: ["active", "show"],
          bodyClass: ["show-popup", "overflow-hidden"]
        };
        if (this.hasAttribute("data-body-class")) {
          this.config.customBodyClass = this.getAttribute("data-body-class").split(",");
        }
      }
      connectedCallback() {
        this.addEventListener("click", (e) => {
          const currentTarget = e.target;
          if (!currentTarget.closest(".popup-content") || currentTarget.closest(".jsClose")) {
            this.close();
            e.stopPropagation();
          }
        });
        window.addEventListener("resize", () => {
          if (!this.isOpen) return;
          const popupContent = this.querySelector(".popup-content");
          if (!popupContent) return;
          inViewPort2(popupContent, (isVisible) => {
            if (!isVisible) {
              this.close();
            }
          });
        });
        this.autoAppend();
        this.autoShow();
      }
      close(callback = null) {
        this.classList.remove(...this.config.activeClass);
        this.querySelectorAll("video-component").forEach((item) => item.videoStop?.());
        if (this.config.customBodyClass) document.body.classList.remove(...this.config.customBodyClass);
        this.removeAttribute("role");
        this.removeAttribute("aria-modal");
        const visibilityCheck = () => {
          const isVisible = window.getComputedStyle(this).opacity;
          if (isVisible != "0") requestAnimationFrame(visibilityCheck);
          else {
            this.isOpen = false;
            if (Array.from(document.querySelectorAll("popup-component")).some((i) => i.isOpen == true)) return;
            document.body.classList.remove(...this.config.bodyClass);
            callback && callback();
            this.dispatchEvent(new CustomEvent("popup:afterClose", { detail: { id: this.id }, bubbles: true }));
          }
        };
        requestAnimationFrame(visibilityCheck);
      }
      open(callback = null) {
        this.setAttribute("role", "dialog");
        this.setAttribute("aria-modal", "true");
        this.classList.add(...this.config.activeClass);
        document.body.classList.add(...this.config.bodyClass);
        if (this.config.customBodyClass) document.body.classList.add(...this.config.customBodyClass);
        const computedStyle = window.getComputedStyle(this);
        const visibilityCheck = () => {
          const isVisible = computedStyle.opacity;
          if (isVisible != "0") {
            this.isOpen = true;
            this.autoHide();
            setTimeout(() => {
              this.querySelector("[auto-focus]")?.focus();
            }, 100);
            callback && callback();
          } else {
            requestAnimationFrame(visibilityCheck);
          }
        };
        requestAnimationFrame(visibilityCheck);
      }
      autoAppend() {
        if (!this.hasAttribute("auto-append")) return;
        this.removeAttribute("auto-append");
        const existingNode = document.getElementById(this.id);
        if (existingNode && existingNode !== this) {
          existingNode.after(this);
          existingNode.remove();
        }
      }
      autoShow() {
        if (!this.hasAttribute("auto-show")) return;
        this.removeAttribute("auto-show");
        setTimeout(() => {
          this.open();
        }, 300);
      }
      autoHide() {
        if (!this.hasAttribute("auto-hide")) return;
        if (this.isHiding != null) clearTimeout(this.isHiding);
        this.isHiding = setTimeout(() => {
          this.close();
          this.isHiding = null;
        }, +this.getAttribute("auto-hide"));
      }
    }
  );

  // app/scripts/common/component/quantity.js
  var QuantityInput = class extends HTMLElement {
    constructor() {
      super();
      this.changeEvent = new Event("change", { bubbles: true });
      this.input = this.querySelector("input");
      if (this.input) {
        this.querySelectorAll("button")?.forEach((button) => {
          button.addEventListener("click", this.onButtonClick.bind(this));
        });
      } else {
        this.querySelector("select")?.addEventListener("change", (e) => {
          this.dispatchEvent(this.changeEvent);
        });
      }
    }
    onButtonClick(event) {
      event.preventDefault();
      const previousValue = this.input.value;
      event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
      if (previousValue !== this.input.value)
        this.input.dispatchEvent(this.changeEvent);
    }
  };
  customElements.define("quantity-input", QuantityInput);

  // app/scripts/common/component/productCart.js
  var productCartForm = class extends cartForm {
    constructor() {
      super();
    }
    connectedCallback() {
      if (theme.settings.cartStyle == "page") return;
      this.form = this.querySelector("form");
      this.form.addEventListener("submit", this.onSubmit.bind(this));
    }
    async onSubmit(event) {
      if (theme.routes.pageType == "cart") {
        if (!this.closest(".js-cart-complete-the-look")) return;
      }
      event?.preventDefault();
      if (!this.form.checkValidity()) {
        this.form.reportValidity();
        return;
      }
      const formData = new FormData(this.form);
      formData.append("sections", this.sectionList());
      formData.append("sections_url", this.dataset.url || location.pathname);
      if (window.bcpo && window.bcpo.$) {
        const sentBy = "theme";
        window.bcpo.$(document).triggerHandler("bcpo:beforeAddToCart", [formData, sentBy]);
      }
      const effect = "default";
      const popupComponent = this.closest("popup-component");
      const productHandle = this.getAttribute("data-product-handle");
      let delay = 10;
      let beforeReRenderCallback = null;
      if (this.closest(".js-cart-complete-the-look")) {
        beforeReRenderCallback = (response) => {
          this.showCheckIcon(response, delay);
        };
      }
      this.postCart(
        "add",
        formData,
        () => {
          if (popupComponent && popupComponent.id != "cartDrawer") this.closest("popup-component")?.close();
          if (!popupComponent || popupComponent.id != "cartDrawer") {
            document.querySelector("cart-component")?.open();
          }
          if (this.getAttribute("data-dynamic-gifting") == "true" && window.discountOnCartProApp?.codes && window.discountOnCartProApp.codes.length <= 1) {
            const lineItem = document.querySelector(`.cart-item-wrapper[data-product-handle="${productHandle}"]`);
            lineItem?.querySelector(`.item-total-price`)?.classList.add("hidden");
            lineItem?.querySelector(`.item-total-price-for-dynamic-gifting`)?.classList.remove("hidden");
          }
        },
        effect,
        delay,
        beforeReRenderCallback
      );
    }
    showCheckIcon(response, delay) {
      const isError = response.status;
      if (isError) return;
      this.closest("product-card").classList.add("is-added");
    }
  };
  !customElements.get("product-cart-form") && customElements.define("product-cart-form", productCartForm);

  // app/scripts/common/component/lazyScript.js
  var customElementsName2 = "lazy-script";
  !window.customElements.get(customElementsName2) && window.customElements.define(customElementsName2, class extends HTMLElement {
    constructor() {
      super();
      if (!("IntersectionObserver" in window) && !("IntersectionObserverEntry" in window) && !("intersectionRatio" in window.IntersectionObserverEntry.prototype)) {
        this.inVisible();
        return;
      }
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.observer.disconnect();
            this.inVisible();
          }
        });
      }, { rootMargin: "400px 0px 400px 0px" });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
    }
    inVisible() {
      setTimeout(() => {
        this.loadFiles();
        this.changeTag();
      }, 100);
    }
    loadFiles() {
      const { file: files } = this.dataset;
      if (!files) return;
      this.removeAttribute("data-file");
      files.split(",").forEach((file) => {
        if (file.includes(".js")) {
          const parts = file.split("/");
          const fileName = parts[parts.length - 1].split(".js")[0];
          if (document.querySelector(`script[data-uniq="${fileName}"]`) || document.querySelector(`script[src*="${file}"]`)) return;
          const script = document.createElement("script");
          script.setAttribute("data-uniq", fileName);
          script.src = file;
          document.head.insertAdjacentElement("beforeend", script);
        } else {
          const parts = file.split("/");
          const fileName = parts[parts.length - 1].split(".css")[0];
          if (document.querySelector(`link[data-uniq="${fileName}"]`)) return;
          const stylesheet = document.createElement("link");
          stylesheet.href = file;
          stylesheet.rel = "stylesheet";
          stylesheet.type = "text/css";
          stylesheet.media = "all";
          stylesheet.setAttribute("data-uniq", fileName);
          document.head.insertAdjacentElement("beforeend", stylesheet);
        }
      });
    }
    changeTag() {
      const { tag = "div" } = this.dataset;
      if (!tag) return;
      const el = document.createElement(tag || "div");
      this.removeAttribute("data-tag");
      Array.from(this.attributes).forEach((attr, i) => {
        el.setAttribute(this.attributes[i].name, this.attributes[i].value);
      });
      Array.from(this.children)?.forEach((child) => {
        el.insertAdjacentElement("beforeend", child);
      });
      this.insertAdjacentElement("beforebegin", el);
      this.remove();
    }
  });

  // app/scripts/common/function/dateFormat.js
  var dateFormat = /* @__PURE__ */ function() {
    var t = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g, e = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g, a = /[^-+\dA-Z]/g, m = function(t2, e2) {
      for (t2 = String(t2), e2 = e2 || 2; t2.length < e2; ) t2 = "0" + t2;
      return t2;
    };
    return function(d, n, r) {
      var y = dateFormat;
      if (1 != arguments.length || "[object String]" != Object.prototype.toString.call(d) || /\d/.test(d) || (n = d, d = void 0), d = d ? new Date(d) : /* @__PURE__ */ new Date(), isNaN(d))
        throw SyntaxError("invalid date");
      "UTC:" == (n = String(y.masks[n] || n || y.masks.default)).slice(0, 4) && (n = n.slice(4), r = true);
      var s = r ? "getUTC" : "get", i = d[s + "Date"](), o = d[s + "Day"](), u = d[s + "Month"](), M = d[s + "FullYear"](), l = d[s + "Hours"](), T = d[s + "Minutes"](), h = d[s + "Seconds"](), c = d[s + "Milliseconds"](), g = r ? 0 : d.getTimezoneOffset(), S = {
        d: i,
        dd: m(i),
        ddd: y.i18n.dayNames[o],
        dddd: y.i18n.dayNames[o + 7],
        m: u + 1,
        mm: m(u + 1),
        mmm: y.i18n.monthNames[u],
        mmmm: y.i18n.monthNames[u + 12],
        yy: String(M).slice(2),
        yyyy: M,
        h: l % 12 || 12,
        hh: m(l % 12 || 12),
        H: l,
        HH: m(l),
        M: T,
        MM: m(T),
        s: h,
        ss: m(h),
        l: m(c, 3),
        L: m(c > 99 ? Math.round(c / 10) : c),
        t: l < 12 ? "a" : "p",
        tt: l < 12 ? "am" : "pm",
        T: l < 12 ? "A" : "P",
        TT: l < 12 ? "AM" : "PM",
        Z: r ? "UTC" : (String(d).match(e) || [""]).pop().replace(a, ""),
        o: (g > 0 ? "-" : "+") + m(100 * Math.floor(Math.abs(g) / 60) + Math.abs(g) % 60, 4),
        S: ["th", "st", "nd", "rd"][i % 10 > 3 ? 0 : (i % 100 - i % 10 != 10) * i % 10]
      };
      return n.replace(t, function(t2) {
        return t2 in S ? S[t2] : t2.slice(1, t2.length - 1);
      });
    };
  }();
  dateFormat.masks = {
    default: "ddd mmm dd yyyy HH:MM:ss",
    shortDate: "m/d/yy",
    mediumDate: "mmm d, yyyy",
    longDate: "mmmm d, yyyy",
    fullDate: "dddd, mmmm d, yyyy",
    shortTime: "h:MM TT",
    mediumTime: "h:MM:ss TT",
    longTime: "h:MM:ss TT Z",
    isoDate: "yyyy-mm-dd",
    isoTime: "HH:MM:ss",
    isoDateTime: "yyyy-mm-dd'T'HH:MM:ss",
    isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"
  }, dateFormat.i18n = {
    dayNames: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    monthNames: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ]
  }, Date.prototype.format = function(t, e) {
    return dateFormat(this, t, e);
  };

  // app/scripts/common/component/estimateArrival.js
  var customElementsName3 = "estimate-arrival-component";
  !window.customElements.get(customElementsName3) && window.customElements.define(
    customElementsName3,
    class extends HTMLElement {
      constructor() {
        super();
        const days = this.dataset.days || this.querySelector("[data-est-standard]").getAttribute("data-est-standard");
        let fecha = this.sumaFecha(parseInt(days));
        let estimated = new Date(fecha);
        if (this.querySelector(".estimated-arrival")) {
          this.querySelector(".estimated-arrival").innerHTML = estimated.format("mmm dS");
        }
      }
      sumaFecha(d) {
        let Fecha = /* @__PURE__ */ new Date();
        let sFecha = Fecha.getDate() + "/" + (Fecha.getMonth() + 1) + "/" + Fecha.getFullYear();
        let sep = sFecha.indexOf("/") != -1 ? "/" : "-";
        let aFecha = sFecha.split(sep);
        let fecha = aFecha[2] + "/" + aFecha[1] + "/" + aFecha[0];
        fecha = new Date(fecha);
        fecha.setDate(fecha.getDate() + parseInt(d));
        let anno = fecha.getFullYear();
        let mes = fecha.getMonth() + 1;
        let dia = fecha.getDate();
        mes = mes < 10 ? "0" + mes : mes;
        dia = dia < 10 ? "0" + dia : dia;
        let fechaFinal = mes + sep + dia + sep + anno;
        return fechaFinal;
      }
    }
  );

  // app/scripts/common/component/productCard.js
  var customElementsName4 = "product-card";
  !window.customElements.get(customElementsName4) && window.customElements.define("product-card", class extends HTMLElement {
    constructor() {
      super();
      if (this.classList.contains("jsStorage")) {
        let product_links = this.querySelectorAll(".product-link");
        product_links.forEach((e) => {
          e.addEventListener("click", (event) => {
            event.preventDefault();
            var collection_cookie = {
              "handle": this.dataset.collectionHandle,
              "id": this.dataset.productId,
              "name": this.dataset.collectionName
            };
            sessionStorage.setItem("collection_cookie", JSON.stringify(collection_cookie));
            let params = new URLSearchParams(window.location.search);
            params.set("page", this.dataset.page);
            window.history.replaceState({}, "", `${window.location.pathname}?${params}`);
            window.location.href = e.href;
          });
        });
      }
    }
  });

  // app/scripts/theme.js
  document.body.addEventListener("keyup", (e) => {
    e.code == "Escape" && document.querySelectorAll("popup-component.active").forEach((popup) => {
      popup.close();
    });
  });
  window.isScriptLoaded = (src) => {
    return [...document.scripts].some((script) => script.src.includes(src));
  };
  document.addEventListener("product-zoom:init", (e) => {
    const selector = e?.detail?.selector;
    const target = e?.detail?.target;
    if (isScriptLoaded("product-image-zoom.js") && window.pswpFunc) {
      window.pswpFunc(selector, target);
    } else {
      const script = document.createElement("script");
      script.src = window.theme.assets.pswp;
      script.onload = () => {
        window.pswpFunc(selector, target);
      };
      document.head.insertAdjacentElement("beforeend", script);
    }
  });
  document.addEventListener("click", function(e) {
    const link = e.target.closest('a[href^="#"]');
    if (!link || link.classList.contains("skip")) return;
    e.preventDefault();
    const targetId = link.getAttribute("href").substring(1);
    const target = document.getElementById(targetId);
    if (target) {
      const paddingTop = parseInt(target.dataset.paddingTop) || 0;
      const header = document.querySelector("header");
      const headerHeight = header ? header.offsetHeight : 0;
      const offsetTop = target.getBoundingClientRect().top + window.scrollY - (headerHeight + paddingTop);
      window.scrollTo({
        top: offsetTop,
        behavior: "smooth"
      });
    }
  });
  var obj = sessionStorage.getItem("collection_cookie");
  obj = JSON.parse(obj);
  if (obj != null) {
    if (window.location.href.includes(obj.handle) || window.location.href.includes("?request=collection")) {
    } else {
      sessionStorage.removeItem("collection_cookie");
    }
  }
  if (document.querySelectorAll(".gw-rv-listing-average-placeholder").length > 0) {
    let hideTargetElements = function() {
      let reviews = document.querySelectorAll(".gw-rv-listing-average-placeholder");
      reviews.forEach((e) => {
        let shadow = e.shadowRoot;
        let insideElement = shadow?.querySelector('[data-gw-rating-count="0"');
        if (insideElement == null) {
          e.style.display = "block";
        } else {
          e.style.display = "none";
        }
      });
    };
    const originalFetch = window.fetch;
    window.fetch = async function(...args) {
      const [resource, config] = args;
      if (resource.includes("growave")) {
        const response = await originalFetch(...args);
        setTimeout(hideTargetElements, 300);
        return response;
      }
      return originalFetch(...args);
    };
    hideTargetElements();
  }
  if (window.location.href.includes("collections")) {
    let lastScrollY = window.scrollY || window.pageYOffset;
    let isMenuHidden = false;
    let scrollThreshold = 20;
    let scrollDelta = 0;
    window.addEventListener("scroll", () => {
      const currentScrollY = window.scrollY || window.pageYOffset;
      const filterComponent = document.querySelector("filter-component");
      const body = document.querySelector("body");
      if (!filterComponent) return;
      if (currentScrollY >= 50) {
        const isScrollingDown = currentScrollY > lastScrollY;
        scrollDelta = isScrollingDown ? scrollDelta + 1 : scrollDelta - 1;
        scrollDelta = Math.max(-scrollThreshold, Math.min(scrollThreshold, scrollDelta));
        if (scrollDelta >= scrollThreshold && !isMenuHidden) {
          body.classList.remove("show-menu");
          body.classList.add("hide-menu");
          isMenuHidden = true;
          scrollDelta = 0;
        } else if (scrollDelta <= -scrollThreshold && isMenuHidden) {
          body.classList.add("show-menu");
          body.classList.remove("hide-menu");
          isMenuHidden = false;
          scrollDelta = 0;
        }
      } else {
        body.classList.add("show-menu");
        body.classList.remove("hide-menu");
        isMenuHidden = false;
        scrollDelta = 0;
      }
      lastScrollY = currentScrollY;
    });
  } else {
    let lastScrollY = window.scrollY || window.pageYOffset;
    window.addEventListener(
      "scroll",
      () => {
        const currentScrollY = window.scrollY || window.pageYOffset;
        const scrolledDistance = Math.abs(currentScrollY - lastScrollY);
        if (scrolledDistance >= 50) {
          if (currentScrollY > lastScrollY) {
            if (currentScrollY >= 50) {
              document.querySelector("body").classList.add("hide-menu");
              document.querySelector("body").classList.remove("show-menu");
            }
          } else {
            document.querySelector("body").classList.add("show-menu");
            document.querySelector("body").classList.remove("hide-menu");
          }
          lastScrollY = currentScrollY;
        }
        if (currentScrollY <= 0) {
          document.querySelector("body").classList.add("header-position-reseted");
        } else {
          document.querySelector("body").classList.remove("header-position-reseted");
        }
      },
      { passive: true }
    );
  }
  window.fetchCartItems = async function(retry = 1) {
    try {
      const response = await fetch(window.Shopify.routes.root + "cart.js");
      if (!response.ok) {
        throw new Error("Something wrongs");
      }
      const cart = await response.json();
      return cart;
    } catch (error) {
      console.error("Fetch error:", error);
      if (retry > 0) {
        return await window.fetchCartItems(retry - 1);
      }
      return null;
    }
  };
  window.changeCartItems = async function(obj2, retry = 1) {
    try {
      const response = await fetch(window.Shopify.routes.root + "cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ obj: obj2 })
      });
      if (!response.ok) {
        throw new Error("Something wrongs");
      }
      return true;
    } catch (error) {
      console.error("Fetch error:", error);
      if (retry > 0) {
        return await window.changeCartItems(obj2, retry - 1);
      }
      return null;
    }
  };
  window.updateCartItems = async function(updates, retry = 1) {
    try {
      const response = await fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ updates })
      });
      if (!response.ok) {
        throw new Error("Something wrongs");
      }
      return true;
    } catch (error) {
      console.error("Fetch error:", error);
      if (retry > 0) {
        return await window.updateCartItems(updates, retry - 1);
      }
      return null;
    }
  };
  (function waitForBCPO() {
    const waitForBCPO2 = setInterval(() => {
      if (window.bcpo && window.bcpo.$) {
        clearInterval(waitForBCPO2);
        setTimeout(() => {
          const checkoutBtns = document.querySelectorAll('[name="checkout"]');
          checkoutBtns.forEach((btn) => {
            btn.disabled = false;
          });
        }, 1e3);
      }
    }, 50);
  })();
  window.setButtonOnSideCart = (value) => {
    return value;
  };
  (function overwriteSelleasyDrawerRefreshFunction() {
    document.addEventListener("DOMContentLoaded", () => {
      const selleasyScript = document.querySelector('script[src*="lb-utils.js"]');
      if (selleasyScript) {
        const intervalId = setInterval(() => {
          if (window?.lbSelleasyUtils?.drawerRefresh) {
            clearInterval(intervalId);
            window.lbSelleasyUtils.drawerRefresh = async () => {
              console.log(":::::arn custom code:::::");
              const res = await fetch(window.Shopify.routes.root + "cart.js");
              const cart = await res.json();
              const triggerID = window.theme.product.id;
              const itemNeedUpdateIndex = cart.items.findIndex((item) => item.product_id == triggerID && item.properties["_lb-product"]);
              const itemNeedUpdate = cart.items[itemNeedUpdateIndex];
              if (itemNeedUpdateIndex < 0) {
                document.dispatchEvent(new CustomEvent("cart:build", { detail: { redirectOrOpenDrawer: true } }));
                return;
              }
              window.addEventListener(
                "cart:ready",
                (evt) => {
                  requestAnimationFrame(async () => {
                    const bcpoForm = document.querySelector(".best-custom-product-options form");
                    if (!bcpoForm || bcpoForm.checkValidity()) {
                      const submitButton = document.querySelector("product-cart-form-bcpo .add-to-cart");
                      $(document).one("bcpo:beforeAddToCart", (e, data, sentBy) => {
                        if (sentBy == "theme") return;
                        for (const [key, value] of Object.entries(itemNeedUpdate["properties"])) {
                          data.append(`properties[${key}]`, value);
                        }
                      });
                      const event = new MouseEvent("click", {
                        bubbles: false,
                        cancelable: true
                      });
                      submitButton.dispatchEvent(event);
                    } else {
                      const form = document.querySelector("product-cart-form-bcpo form");
                      const formData = new FormData(form);
                      for (const [key, value] of Object.entries(itemNeedUpdate["properties"])) {
                        formData.append(`properties[${key}]`, value);
                      }
                      if (window.bcpo && window.bcpo.$) {
                        const sentBy = "theme";
                        window.bcpo.$(document).triggerHandler("bcpo:beforeAddToCart", [formData, sentBy]);
                      }
                      const newFormData = new FormData();
                      for (const [key, value] of formData.entries()) {
                        if (/^properties\[[^\]]+\]$/.test(key)) {
                          newFormData.append(key, value);
                        }
                      }
                      newFormData.append("line", itemNeedUpdateIndex + 1);
                      const response = await fetch(`${theme.routes.cartUrl}/change.js`, {
                        method: "POST",
                        body: newFormData
                      });
                      const json = await response.json();
                      if (json.status) {
                        console.error(response);
                      }
                      document.dispatchEvent(new CustomEvent("cart:build", { detail: { redirectOrOpenDrawer: true } }));
                    }
                  });
                },
                { once: true }
              );
              document.dispatchEvent(new CustomEvent("cart:build"));
            };
          }
        }, 50);
      }
    });
  })();
  (function growaveWishlistAddToCartHandler() {
    function wishlistCardObserver(element) {
      const targetNode = element;
      const config = { childList: true, subtree: true };
      let done = false;
      const callback = (mutationList, observer2) => {
        for (const mutation of mutationList) {
          if (mutation.type === "childList") {
            if (mutation.target.closest(`a[href*="/cart"]`) || mutation.target.closest(`a[href*="${window.Shopify.routes.root + "cart"}"]`)) {
              if (!done) {
                done = true;
                observer2.disconnect();
                document.dispatchEvent(new CustomEvent("cart:build", { detail: { redirectOrOpenDrawer: true } }));
                const cartDrawer = document.querySelector("cart-component");
                cartDrawer.style.pointerEvents = "none";
                window.addEventListener(
                  "cart:ready",
                  (evt) => {
                    cartDrawer.style.pointerEvents = "auto";
                  },
                  { once: true }
                );
                document.dispatchEvent(new CustomEvent("cart:build"));
              }
            }
          }
        }
      };
      const observer = new MutationObserver(callback);
      observer.observe(targetNode, config);
    }
    function onSdkReady2() {
      const cartModuleName = window.gw.sdk.common.constants.modules.CART;
      window.gw.sdk.runIfModuleReady(cartModuleName, () => {
        window.gw.sdk.registerHook(window.gw.sdk.cart.hooks.ADD_ITEM, async (input) => {
          const variantID = input.items[0].variantID;
          const cardItem = document.querySelector(`.gw-wl-page-item[data-gw-variant-id="${variantID}"]`);
          const productImage = cardItem.querySelector(".gw-wl-page-item__image");
          const productHandle = productImage.href.split("/products/")[1].split("?")[0].trim();
          const productATCButtonWrapper = cardItem.querySelector(".gw-wl-page-item__cart-btn");
          wishlistCardObserver(productATCButtonWrapper);
          const res = await fetch(`${theme.routes.searchUrl}?view=product_atc_mtf&q=${productHandle}`);
          const text = await res.text();
          const div = document.createElement("div");
          div.innerHTML = text;
          const formData = new FormData();
          if (window.bcpo && window.bcpo.$) {
            const sentBy = "theme";
            window.bcpo.$(document).triggerHandler("bcpo:beforeAddToCart", [formData, sentBy]);
          }
          const properties = {};
          for (const pair of formData.entries()) {
            const propKey = pair[0].split("[")[1].slice(0, -1);
            const propValue = pair[1];
            properties[propKey] = propValue;
          }
          if (div.querySelectorAll("input").length > 0) {
            [...div.querySelectorAll("input")].forEach((input2) => {
              const propKey = input2.name.split("[")[1].slice(0, -1);
              const propValue = input2.value;
              properties[propKey] = propValue;
            });
          }
          if (Object.keys(properties).length > 0) {
            return {
              items: input.items.map((item) => ({
                ...item,
                properties
              }))
            };
          } else {
            return {
              items: input.items
            };
          }
        });
      });
    }
    if (window.gw && window.gw.sdk) {
      onSdkReady2();
    } else {
      document.addEventListener("gwSdkReady", onSdkReady2);
    }
  })();
  async function migrateToLocalForage(prefixes, ttlDays = 3) {
    const keys = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (prefixes.some((p) => k.startsWith(p))) keys.push(k);
    }
    console.log("migrateToLocalForage:keys::", keys);
    for (const key of keys) {
      const raw = localStorage.getItem(key);
      let value = raw;
      try {
        value = JSON.parse(raw);
      } catch (_) {
      }
      try {
        await window.theme.set(key, value, ttlDays);
      } catch (err) {
        console.error(`[migrate] ${key}: l\u1ED7i ghi localForage`, err);
      }
      localStorage.removeItem(key);
    }
  }
  (async () => {
    if (!localStorage.getItem("localforage_migration_done_v1")) {
      const PREFIXES = ["sartoro_", "sartoro_suit_", "arn_saved_customization"];
      await migrateToLocalForage(PREFIXES);
      localStorage.setItem("localforage_migration_done_v1", "1");
      document.dispatchEvent(new Event("theme:migrated"));
    }
  })();
  window.arnDaysUntilExpiry = 3;
  var popup_wishlist = document.querySelector("#popupWishlist");
  function deployPopup(element, message) {
    popup_wishlist.querySelector(".text").innerHTML = message;
    popup_wishlist.querySelector(".product-title").innerHTML = element.getAttribute("data-gw-product-title");
    popup_wishlist.querySelector(".product-image img").src = element.getAttribute("data-gw-product-image");
    popup_wishlist.classList.add("active");
    setTimeout(() => {
      popup_wishlist.classList.remove("active");
    }, 4e3);
  }
  function subscribeToWishlistItemCreated() {
    const wishlistItemCreatedEventType = window.gw.sdk.wishlists.events.WISHLIST_ITEM_CREATED;
    window.gw.sdk.on(wishlistItemCreatedEventType, (event) => {
      const event_id = event.detail.productId;
      document.querySelectorAll(".gw-add-to-wishlist-product-card-placeholder, .gw-wl-add-to-wishlist-placeholder").forEach((e) => {
        if (e.getAttribute("data-gw-product-id") == event_id) {
          deployPopup(e, "Product added to wishlist");
        }
      });
    });
  }
  function subscribeToWishlistItemDeleted() {
    const wishlistItemDeletedEventType = window.gw.sdk.wishlists.events.WISHLIST_ITEM_DELETED;
    window.gw.sdk.on(wishlistItemDeletedEventType, (event) => {
      const event_id = event.detail.productId;
      document.querySelectorAll(".gw-add-to-wishlist-product-card-placeholder, .gw-wl-add-to-wishlist-placeholder").forEach((e) => {
        if (e.getAttribute("data-gw-product-id") == event_id) {
          deployPopup(e, "Product removed form wishlist");
        }
      });
    });
  }
  function onSdkReady() {
    const moduleName = window.gw.sdk.common.constants.modules.WISHLISTS;
    window.gw.sdk.runIfModuleReady(moduleName, () => {
      subscribeToWishlistItemCreated();
      subscribeToWishlistItemDeleted();
    });
  }
  if (window.gw && window.gw.sdk) {
    onSdkReady();
  } else {
    document.addEventListener("gwSdkReady", onSdkReady);
  }
})();
